const API_LIST = {
  //用户注册
  userRegist: {
    method: "post",
    url: "registAction"
  },

  //教育局安全地图--用户登录
  eduUserLogin: {
    method: "post",
    url: "/user/education/bureau/jump/login"
  },

  //用户登录
  userLogin: {
    method: "post",
    url: "userLogin"
  },

  //获取图片验证码
  getCaptureCode: {
    method: "get",
    url: "/tool/generate/dynamic/verification/code"
  },

  //金水区科大讯飞授权登录
  authorizeLogin: {
    method: "post",
    url: "/user/ticket/login"
  },

  // ticket登录
  xyeAuthorizeLogin: {
    method: "post",
    url: "/user/xye/user/ticket/login",
    isParams: true
  },

  //金水区科大讯飞使用ticket获取信息
  getTicketInfo: {
    method: "post",
    url: "/backend/get/user/info/by/ticket",
    config: {
      headers: {
        "Content-type": "application/x-www-form-urlencoded;charset=utf-8"
      },
    }
  },

  //获取服务器系统时间
  getServerTime: {
    method: "get",
    url: "/tools/server/timestamp"
  },

  //获取角色数据
  getRoleDataList: {
    method: "post",
    url: "/school/show/all/characters"
  },

  // 获取全部角色
  getAllRoleData: {
    method: "post",
    url: "/school/get/role/list"
  },

  //更改角色状态
  setRoleStatus: {
    method: "post",
    url: "/school/role/permissions/on/and/off"
  },

  // 获取角色成员
  getRoleMemberList: {
    method: "post",
    url: "/school/list/role/members"
  },

  // 添加角色成员
  addRoleMember: {
    method: "post",
    url: "/school/add/role/members/in/bulk"
  },

  // 删除角色成员
  delRoleMember: {
    method: "post",
    url: "/school/delete/role/list/person"
  },

  //新增角色
  addRoleData: {
    method: "post",
    url: "/school/add/permission/role"
  },

  // 更新角色
  editRoleData: {
    method: "post",
    url: "/role/permissions/upd/role/information"
  },

  //删除角色
  deleteRoleData: {
    method: "post",
    url: "/school/role/bulk/deletion"
  },

  //获取部门数据列表
  departmentList: {
    method: "post",
    url: "/school/DepartmentfindPage"
  },

  //删除部门
  deleteDepartmen: {
    method: "post",
    url: "/school/Batchdeletiondepartment"
  },

  // 新增部门
  addDepartmen: {
    method: "post",
    url: "/school/Departmentofquery"
  },

  // 获取安全小组（废弃）
  getSecurityGroupListOld: {
    method: "get",
    url: "/school/show/safety/team/members"
  },

  // 获取安全小组
  getSecurityGroupList: {
    method: "get",
    url: "/school/get/security/team"
  },

  // 获取全部安全小组
  getAllSecurityGroupList: {
    method: "post",
    url: "/school/get/security/team/leader/all"
  },

  // 删除安全小组 /批量删除
  delSecurityTeam: {
    method: "post",
    url: "/school/del/security/teams/in/bulk"
  },

  // 更新安全小组数据
  updateSecurityTeam: {
    method: "post",
    url: "/school/security/team/members/deleted"
  },

  // 教师部门展示
  teacherDepartment: {
    method: "post",
    url: "/school/Departmentofchoices"
  },

  // 获取所有老师
  getAllTeachers: {
    method: "post",
    url: "school/user/pull/down/data"
  },

  // 新增安全小组
  addSecurityTeam: {
    method: "post",
    url: "/school/security/team/creation"
  },

  // 设置安全小组
  settingSafetyGruop: {
    method: "post",
    url: "/school/set/asa/hidden/danger/group"
  },

  // 获取隐患预设地点
  getHiddenDangerPresetLocation: {
    method: "post",
    url: "/Prevention/Hiddentroublepage"
  },

  // 新增隐患预设地点
  addHiddenDangerPresetLocation: {
    method: "post",
    url: "/Prevention/Hiddendangerinsert"
  },

  // 删除隐患预设地点
  delHiddenDangerPresetLocation: {
    method: "post",
    url: "/Prevention/Batchdeletionhiddendanger"
  },

  // 获取隐患分类
  getHiddenDangerClassification: {
    method: "post",
    url: "/Prevention/Hiddendangertypepage"
  },

  // 新增隐患分类
  addHiddenDangerClassification: {
    method: "post",
    url: "/Prevention/Hiddendangertypeinsert"
  },

  // 删除隐患分类
  delHiddenDangerClassification: {
    method: "post",
    url: "/Prevention/Hiddendangertypedelete"
  },

  // 获取管控风险管理信息
  workInfo: {
    method: "get",
    url: "/risk/workInfo"
  },

  // 编辑风险管理小组
  workGroupEdit: {
    method: "post",
    url: "/risk/workGroup/edit"
  },

  // 单文件上传
  oneFileUpload: {
    method: "post",
    url: "/file/upload"
  },

  // 文件下载
  fileDownload: {
    method: "get",
    url: "/file/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 添加风险管理方案
  addWorkProject: {
    method: "post",
    url: "/risk/workProject/add"
  },

  // 获取风险清单
  getRiskList: {
    method: "get",
    url: "/risk/type"
  },

  // 获取风险模型
  getRiskModel: {
    method: "get",
    url: "/risk/model"
  },

  // 获取风险风险辨识
  getRiskIdentification: {
    method: "get",
    url: "/risk/riskIdentify"
  },

  // 删除风险管理方案
  delManagementPlan: {
    method: "get",
    url: "/risk/workProject/del"
  },

  // 添加风险辨识任务
  addRiskIdentification: {
    method: "post",
    url: "/risk/riskIdentify/add"
  },

  // 修改风险辨识任务
  updateRiskIdentification: {
    method: "post",
    url: "/risk/riskIdentify/edit"
  },

  // 获取检查对象
  getCheckObject: {
    method: "get",
    url: "/risk/riskIdentify/model"
  },

  // 绑定检查对象
  bindingCheckObject: {
    method: "post",
    url: "/risk/riskIdentify/model/edit"
  },

  // 删除风险辨识
  delRiskIdentification: {
    method: "post",
    url: "/risk/riskIdentify/del"
  },

  // 获取风险评估
  getRiskEvaluationList: {
    method: "get",
    url: "/risk/riskAudit/model"
  },

  // 导入风险评估
  importRiskAssessment: {
    method: "post",
    url: "/risk/riskAudit/import"
  },

  // 导入风险评估（台账）
  importRiskAssessmentInfo: {
    method: "post",
    url: "/tools/v1/school/model/auto/import"
  },

  // 导出风险评估
  exportRiskAssessment: {
    method: "get",
    url: "/risk/get/risk/model/school/export",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 删除全部风险评估
  delRiskAssessment: {
    method: "get",
    url: "/risk/riskAudit/info/del"
  },

  // 重置风险点编号
  resetRiskAssessmentNum: {
    method: "get",
    url: "/risk/point/number/edit"
  },

  // 提交风险评估审核信息
  setRiskAssessmentExamineInfo: {
    method: "post",
    url: "/risk/riskAudit/info/auditing/edit"
  },

  // 获取风险评估审核信息
  getRiskAssessmentExamineInfo: {
    method: "get",
    url: "/risk/riskAudit/info/auditing"
  },

  // 获取风险评估信息
  getRiskAssessmentInfo: {
    method: "get",
    url: "/risk/riskAudit/info"
  },

  // 提交风险评估信息
  setRiskAssessmentInfo: {
    method: "post",
    url: "/risk/riskAudit/info/edit"
  },

  // 获取分级管控清单
  getLevelControlList: {
    method: "get",
    url: "/risk/riskLevel/info"
  },

  // 获取风险告知卡信息
  getRiskNotificationCard: {
    method: "get",
    url: "/risk/riskNotice/InformCard"
  },

  // 添加风险告知卡信息
  addNotificationCard: {
    method: "post",
    url: "/risk/riskNotice/InformCard/add"
  },

  // 删除风险告知卡信息
  deleteNotificationCard: {
    method: "post",
    url: "/risk/delete/major/risk/announcement/pictures"
  },

  // 获取风险公告图片
  getRiskNoticePicture: {
    method: "get",
    url: "/risk/riskNotice/info"
  },

  // 添加风险告公告图片
  addRiskNoticePicture: {
    method: "post",
    url: "/risk/riskNotice/info/add"
  },

  // 添加风险告公告图片
  deleteRiskNoticePicture: {
    method: "post",
    url: "/risk/delete/the/security/risk/notification/card"
  },

  // 获取风险等级四色图列表(不带详情数据的)
  riskFourColorsPictureListOne: {
    method: "get",
    url: "/risk/riskLevel/img/list"
  },

  // 获取风险等级四色图列表(附带详情数据的)
  riskFourColorsPictureListTwo: {
    method: "post",
    url: "/risk/riskLevel/img"
  },

  // 风险等级四色图操作 新增/修改
  riskFourColorsPictureOperate: {
    method: "post",
    url: "/risk/riskLevel/img/operate"
  },

  // 风险等级四色图操作 删除
  riskFourColorsPictureDel: {
    method: "get",
    url: "/risk/riskLevel/img/del"
  },

  // 获取风险等级四色图数据
  fourColorsPictureData: {
    method: "post",
    url: "/risk/riskLevel/compare"
  },

  // 创建告知模板
  creatNoticeTemplate: {
    method: "post",
    url: "/risk/add/notification/template"
  },

  // 告知模板列表
  getNoticeTemplateList: {
    method: "post",
    url: "/risk/sel/notification/template"
  },

  // 删除告知模板
  delNoticeTemplate: {
    method: "post",
    url: "/risk/del/notification/template"
  },

  // 更新告知模板
  updateNoticeTemplate: {
    method: "post",
    url: "/risk/upd/notification/template"
  },

  // 导入预设数据
  importNoticeTemplateDefault: {
    method: "post",
    url: "/risk/bulk/addPreset/announcement/data"
  },

  // 展示预设数据
  getNoticeTemplateDefault: {
    method: "get",
    url: "/risk/sel/preset/announcement/data"
  },

  // 删除预设数据
  delNoticeTemplateDefault: {
    method: "post",
    url: "/risk/del/preset/announcement/data"
  },

  // 编辑预设数据
  editNoticeTemplateDefault: {
    method: "post",
    url: "/risk/upd/preset/announcement/data"
  },

  // 获取八台账行数信息
  getRiskEightBookRow: {
    method: "get",
    url: "/risk/eight/standing/book/row"
  },

  // 获取自增长行数信息
  getRiskAutoRow: {
    method: "get",
    url: "/risk/rid/row"
  },

  // 获取制度建设资料
  getInstitutionalBuilding: {
    method: "get",
    url: "/risk/institution"
  },

  // 添加制度建设资料
  addInstitutionalBuilding: {
    method: "post",
    url: "/risk/institution/add"
  },

  // 删除制度建设资料
  delInstitutionalBuilding: {
    method: "post",
    url: "/risk/institution/del"
  },

  // 获取安全风险单元划分
  getRiskUnitDivision: {
    method: "get",
    url: "/risk/unit/division"
  },

  // 导出安全风险单元划分
  exportRiskUnitDivision: {
    method: "get",
    url: "/risk/unit/division/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取危险源辨识及风险分析
  getRiskIdentificationAnalysis: {
    method: "get",
    url: "/risk/hazard/identification/analysis"
  },

  // 导出危险源辨识及风险分析
  exportRiskIdentificationAnalysis: {
    method: "get",
    url: "/risk/hazard/identification/analysis/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取风险点清单
  getRiskInventoryList: {
    method: "get",
    url: "/risk/inventory"
  },

  // 导出风险点清单
  exportRiskInventoryList: {
    method: "get",
    url: "/risk/inventory/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取安全风险辨识管控台账
  getAccountDataList: {
    method: "get",
    url: "/risk/riskLevel/standingBook"
  },

  // 导出安全风险辨识管控台账
  exportRiskStandingBook: {
    method: "get",
    url: "/risk/standing/book/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取风险管控责任清单
  getRiskControlList: {
    method: "get",
    url: "/risk/control/responsibility/inventory"
  },

  // 导出风险管控责任清单
  exportRiskControlList: {
    method: "get",
    url: "/risk/control/responsibility/inventory/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取安全风险数据库
  getRiskDatabase: {
    method: "get",
    url: "/risk/database"
  },

  // 导出安全风险数据库
  exportRiskDatabase: {
    method: "get",
    url: "/risk/database/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取隐患排查表
  getRiskHiddenDanger: {
    method: "get",
    url: "/risk/hidden/danger/check/list"
  },

  // 导出隐患排查表
  exportRiskHiddenDanger: {
    method: "get",
    url: "/risk/hidden/danger/check/list/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取查询区域数据
  getQueryRegion: {
    method: "get",
    url: "/Prevention/get/inspection/area"
  },

  // 常规检查-预设事项-系统检查项1
  inspectionItemsOne: {
    method: "post",
    url: "/Prevention/Hiddendangerinspectionitem"
  },

  // 常规检查-预设事项-系统检查项2
  inspectionItemsTwo: {
    method: "post",
    url: "/Prevention/Safetycheckitem"
  },

  // 添加巡查区域
  addPatrolRegion: {
    method: "post",
    url: "/Prevention/Addinspectionarea"
  },

  // 修改巡查区域
  setPatrolRegion: {
    method: "post",
    url: "/Prevention/UpdateregionalPatrol"
  },

  // 查询单挑巡查区域
  getOnePatrolRegion: {
    method: "post",
    url: "/Prevention/QueryregionbyregionalPatrolId"
  },

  // 删除巡查区域
  delPatrolRegion: {
    method: "post",
    url: "/Prevention/BatchdeletionregionalPatrol"
  },

  // 导出巡查区域
  exportPatrolRegion: {
    method: "post",
    url: "/Holiday/export/excel",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导入巡查区域
  importPatrolRegion: {
    method: "post",
    url: "/Prevention/insertexcelAddinspectionarea",
    responseType: "blob"
  },

  // 获取规避时间数据
  getCircumventionTimeData: {
    method: "post",
    url: "/Holiday/selectByschooid"
  },

  // 获取所有巡查区域
  getAllPatrolRegion: {
    method: "get",
    url: "/Prevention/regional/patrol/list"
  },

  // 修改规避时间数据
  setCircumventionTimeData: {
    method: "post",
    url: "/Holiday/dateAvoidanceTime"
  },

  // 删除例外时间
  deleteExceptionTime: {
    method: "post",
    url: "/Holiday/DeleteExceptionTime"
  },

  // 添加例外时间
  addExceptionTime: {
    method: "post",
    url: "/Holiday/asingleExceptionTime"
  },

  // 获取选择任务
  getInspectTask: {
    method: "post",
    url: "/Holiday/selecttaskdailyTaskName"
  },

  // 清空规避时间
  clearEvasionTime: {
    method: "post",
    url: "/Holiday/Deletethedate"
  },

  // 获取规避数据
  getAvoidData: {
    method: "get",
    url: "/Holiday/avoidance/time/inspection/tasks"
  },

  // 获取所有巡查任务
  getAllTask: {
    method: "get",
    url: "/Holiday/task/avoiding/holidays"
  },

  // 导出巡查任务
  exportPatrolTask: {
    method: "get",
    url: "/Prevention/patrols/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 添加节假日规避任务
  addHolidayTask: {
    method: "post",
    url: "/Holiday/holiday/avoidance/task/added"
  },

  // 删除节假日规避任务
  delHolidayTask: {
    method: "post",
    url: "/Holiday/holiday/avoidance/task/rm"
  },

  // 保存周具体日期的规避
  setAvoidDateData: {
    method: "post",
    url: "/Holiday/avoid/time/saving"
  },

  // 获取日常巡查
  getDailyInspectionData: {
    method: "post",
    url: "/Prevention/Inquireaboutallinspectiontasks"
  },

  // 日常巡查批量启用
  dailyInspectionBatchEnable: {
    method: "post",
    url: "/Prevention/Batchopenstate"
  },

  // 日常巡查批量禁用
  dailyInspectionBatchDisable: {
    method: "post",
    url: "/Prevention/Batchclosestate"
  },

  // 删除日常巡查
  dailyInspectionDelete: {
    method: "post",
    url: "/Prevention/Batchdeletedailytask"
  },

  // 隐藏巡查任务（保留巡查记录）
  dailyInspectionHide: {
    method: "post",
    url: "/Prevention/daily/task/hide"
  },

  // 获取部门及负责人
  getDepartmentHead: {
    method: "post",
    url: "/school/Departmentofchoices"
  },

  // 获取巡查点
  getPatrolPoint: {
    method: "post",
    url: "/Prevention/regionalPatrolList"
  },

  // 新增任务
  newTask: {
    method: "post",
    url: "/Prevention/DailyTaskinsert"
  },

  // 获取任务详情
  getTaskDetails: {
    method: "post",
    url: "/Prevention/Queryinformation"
  },

  // 删除任务时间段
  deleteTimePeriod: {
    method: "post",
    url: "/Prevention/Deletetimeperiod"
  },

  // 编辑任务详情
  editTaskDetails: {
    method: "post",
    url: "/Prevention/updateTimeQuantum"
  },

  // 日常巡查记录
  dailyPatrolRecord: {
    method: "get",
    url: "/Prevention/patrol/record"
  },

  // 日常巡查记录详情
  dailyPatrolRecordDetails: {
    method: "get",
    url: "/Prevention/patrol/record/info"
  },

  // 获取定点列表
  getPatrolLocationList: {
    method: "get",
    url: "/pi/get/targeting/list"
  },

  // 批量删除定点
  delPatrolLocation: {
    method: "post",
    url: "/pi/del/position"
  },

  // 更新定点状态
  updatePatrolLocationStatus: {
    method: "post",
    url: "/pi/upd/targeting/status"
  },

  // 编辑巡查人员
  editPatrolLocationPeople: {
    method: "post",
    url: "/pi/ins/inspector"
  },

  // 获取巡查人员
  getPatrolLocationPeople: {
    method: "get",
    url: "/pi/get/inspector"
  },

  // 清空巡查人员
  delPatrolLocationPeople: {
    method: "post",
    url: "/pi/del/inspector"
  },

  // 巡查任务生成
  createPatrolLocationTask: {
    method: "post",
    url: "/pi/ins/mission/record"
  },

  // 获取定点列表巡查记录
  getPatrolLocationListRecord: {
    method: "get",
    url: "/pi/get/mission/record"
  },

  // 安全事故列表
  safetyAccidentList: {
    method: "post",
    url: "/safe/manage/accident"
  },

  // 安全事故列表
  exportSafetyAccidentList: {
    method: "get",
    url: "/safe/manage/accident/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 新增安全事故
  addSafetyAccident: {
    method: "post",
    url: "/safe/manage/accident/add"
  },

  // 获取安全事故详情
  getSafetyAccidentDetails: {
    method: "post",
    url: "/safe/manage/accident/reveal"
  },

  // 获取安全事故续报
  getSafetyAccidentReporting: {
    method: "post",
    url: "/safe/manage/accident/process"
  },

  // 编辑安全事故续报
  editSafetyAccidentReporting: {
    method: "post",
    url: "/safe/manage/accident/process/edit"
  },

  // 提交结案信息
  submitCaseInfo: {
    method: "post",
    url: "/safe/manage/accident/close/add"
  },

  // 导出今日巡查任务详情
  exportPatrolTaskDetails: {
    method: "get",
    url: "/Prevention/patrol/record/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导出日常巡查人员记录
  exportPatrolUserLog: {
    method: "get",
    url: "/Prevention/patrol/record/user/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导出巡查任务详情
  exportTaskDetails: {
    method: "get",
    url: "/Prevention/task/completion/status/between/export/time/periods",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导出巡查人员记录
  exportUserLog: {
    method: "get",
    url: "/Prevention/user/completion/between/export/time/periods",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取隐患数据列表
  getHiddenDangerList: {
    method: "post",
    url: "/Holiday/check/all/hidden/dangers"
  },

  // 获取隐患负责人
  getHiddenDangerPerson: {
    method: "post",
    url: "/school/get/security/team/leader"
  },

  // 上报隐患
  reportHiddenDanger: {
    method: "post",
    url: "/Holiday/ReportTheHazard"
  },

  // 隐患详情
  hazardDetails: {
    method: "get",
    url: "/Holiday/view/individual/hazards"
  },

  // 提交隐患撤销
  submitHiddenDangerRevoke: {
    method: "post",
    url: "/Holiday/updateInsertthe"
  },

  // 获取全部隐患类型
  getAllHiddenDangerType: {
    method: "post",
    url: "/Holiday/hiddendangerclassifyByschoolId"
  },

  // 隐患指派
  hiddenDangerAssign: {
    method: "post",
    url: "/Holiday/InsertAssignhandler"
  },

  //隐患处理
  hiddenDangerHandle: {
    method: "post",
    url: "/Holiday/InsertProcessinghiddentrouble"
  },

  // //隐患转派
  // hiddenDangerTransfer:{
  //     method: 'post',
  //     url: '/Holiday/redeploythehiddenstatepass',
  // },

  //隐患转派
  hiddenDangerTransfer: {
    method: "post",
    url: "/hazard/management/hidden/danger/transfer"
  },

  // 隐患验收 通过/不通过
  hiddenDangerInspect: {
    method: "post",
    url: "/Holiday/Acceptanceofhiddentrouble"
  },

  // // 重大隐患数据
  // hiddenDangerInspect: {
  //     method: 'get',
  //     url: '/Holiday/supervise/major/hidden/dangers',
  // },

  // // 过期隐患数据
  // hiddenDangerInspect: {
  //     method: 'get',
  //     url: '/Holiday/supervise/the/overdue/hidden/danger',
  // },

  // // 督办提醒
  // hiddenDangerInspect: {
  //     method: 'get',
  //     url: '/Holiday/hidden/danger/warning',
  // },

  // 学校隐患督办个数
  schoolHiddenDangerSuperviseNumber: {
    method: "get",
    url: "/hazard/management/school/number/of/Supervisions"
  },

  // 学校隐患督办数据
  schoolHiddenDangerSuperviseData: {
    method: "get",
    url: "/hazard/management/get/school/supervise/data"
  },

  // 学校查看隐患详情信息
  schoolHiddenDangerSuperviseDetail: {
    method: "get",
    url: "/hazard/management/get/hazard/details"
  },

  // 教育局校内隐患预警
  getEduHiddenDangerWarning: {
    method: "get",
    url: "/districteb/get/hidden/danger/alarm"
  },

  // 教育局校内护学岗用户列表
  getEduhxgList: {
    method: "post",
    url: "/hxg/get/hxg/user/list"
  },
  //  护学岗用户新增
  addEduhxgUser: {
    method: "post",
    url: "/hxg/add/nursing/user/"
  },
  //  护学岗用户删除
  deleteEduhxgUser: {
    method: "post",
    url: "/hxg/del/hxg/user"
  },
  //  护学岗用户修改
  editEduhxgUser: {
    method: "post",
    url: "/hxg/upd/hxg/user/info"
  },
  //  教育局护学岗记录
  gethxgRecordsList: {
    method: "get",
    url: "/hxg/get/records/list"
  },
  //护学岗批量导入
  uploadFileHxg: {
    method: "post",
    url: "/hxg/batch/add/hxg/user"
  },
  //  导出教育局护学岗记录
  exportRecord: {
    method: "get",
    url: "/hxg/export/entry/record",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },


  // 教育局校内隐患数据
  getEduHiddenDangerData: {
    method: "get",
    url: "/hazard/management/get/school/hidden/dangers"
  },

  // 教育局校内隐患数据(2023.4.27)
  getEduHiddenDangerDataNew: {
    method: "get",
    url: "/v1/get/school/hidden/danger/list"
  },

  // 获取隐患督办列表（教育局隐患督办数据）
  getEduHiddenDangerSuperviseList: {
    method: "get",
    url: "/hazard/management/get/supervise/data"
  },

  // 督办隐患
  doHiddenDangerSupervise: {
    method: "post",
    url: "/hazard/management/supervise/hidden/dangers"
  },

  // 查看隐患详情信息
  eduHiddenDangerSuperviseDetail: {
    method: "get",
    url: "/hazard/management/get/hazard/details"
  },

  // 隐患督办个数
  eduHiddenDangerSuperviseNumber: {
    method: "get",
    url: "/hazard/management/number/of/Supervisions"
  },

  // 结束督办
  completeHiddenDangerSupervise: {
    method: "post",
    url: "/hazard/management/update/supervision/status"
  },

  // 下发整改文件
  issueHiddenDangerSuperviseFile: {
    method: "post",
    url: "/hazard/management/add/issue/documents"
  },

  // 编辑整改文件
  editHiddenDangerSuperviseFile: {
    method: "post",
    url: "/hazard/management/upd/issue/documents"
  },

  // 查看下发文件内容
  checkHiddenDangerSuperviseFile: {
    method: "get",
    url: "/hazard/management/sel/issue/documents"
  },

  // 隐患督办人员获取
  getHiddenDangerSupervisePerson: {
    method: "get",
    url: "/user/get/all/staff/the/education/bureau"
  },

  // 获取校园广播品牌
  getBroadcastBrand: {
    method: "get",
    url: "/safe/iot/voice/brand"
  },

  // 编辑学校广播品牌
  editBroadcastBrand: {
    method: "get",
    url: "/safe/iot/voice/brand/edit"
  },

  // 获取校园广播区域
  getBroadcastRegion: {
    method: "get",
    url: "/safe/iot/voice/area"
  },

  // 获取全部校园广播区域
  getBroadcastAllRegion: {
    method: "get",
    url: "/safe/iot/voice/area/all"
  },

  // 新增 / 编辑 校园广播区域
  broadcastRegionOperation: {
    method: "post",
    url: "/safe/iot/voice/area/operate"
  },
  // 校园广播区域（获取分区信息）
  getBroadcastBindingArea: {
    method: "get",
    url: "/safe/iot/voice/partition/info"
  },
  // 校园广播区域（编辑分区信息）
  editBroadcastBindingArea: {
    method: "post",
    url: "/safe/iot/voice/partition/info/edit"
  },
  // 删除校园广播区域
  delBroadcastRegion: {
    method: "get",
    url: "/safe/iot/voice/area/del"
  },

  // 获取广播区域下广播控制器
  getBroadcastController: {
    method: "get",
    url: "/safe/iot/voice/conr"
  },

  // 添加/编辑广播区域下广播控制器
  operateBroadcastController: {
    method: "post",
    url: "/safe/iot/voice/conr/operate"
  },

  // 删除广播区域下广播控制器
  delBroadcastController: {
    method: "post",
    url: "/safe/iot/voice/conr/del"
  },

  // 获取广播控制器下广播分区
  getBroadcastControllerArea: {
    method: "get",
    url: "/safe/iot/voice/partition"
  },

  // 添加/编辑广播控制器下广播分区
  operateBroadcastControllerArea: {
    method: "post",
    url: "/safe/iot/voice/partition/operate"
  },

  // 删除广播控制器下分区设备
  delBroadcastControllerArea: {
    method: "post",
    url: "/safe/iot/voice/partition/del"
  },

  // 获取校园广播分组
  getBroadcastPacket: {
    method: "get",
    url: "/safe/iot/voice/group"
  },

  // 新增 / 编辑 校园广播分组
  broadcastPacketOperation: {
    method: "post",
    url: "/safe/iot/voice/group/operate"
  },

  // 删除校园广播分组
  delBroadcastGroup: {
    method: "get",
    url: "/safe/iot/voice/group/del"
  },

  // 获取广播资源
  getBroadcastResources: {
    method: "get",
    url: "/safe/iot/voice"
  },

  // 新增 / 编辑 校园广播资源
  broadcastResourcesOperation: {
    method: "post",
    url: "/safe/iot/voice/operate"
  },

  // 删除校园广播资源
  delBroadcastResources: {
    method: "get",
    url: "/safe/iot/voice/del"
  },

  // 获取系统广播
  getSystemBroadcast: {
    method: "get",
    url: "/safe/iot/voice/system"
  },

  // 添加广播记录
  addBroadcastRecord: {
    method: "post",
    url: "/safe/iot/voice/play/record/add"
  },

  // 获取广播记录
  getBroadcastRecord: {
    method: "get",
    url: "/safe/iot/voice/play/record"
  },

  // 获取作息表分类列表
  getBroadcastRest: {
    method: "get",
    url: "/safe/iot/voice/schedule/types"
  },

  // 获取单个作息表分类信息
  getBroadcastRestInfo: {
    method: "get",
    url: "/safe/iot/voice/schedule/type"
  },

  // 添加或编辑作息表分类
  addOrEditBroadcastRest: {
    method: "post",
    url: "/safe/iot/voice/schedule/type/operate"
  },

  // 删除作息表分类
  delBroadcastRest: {
    method: "get",
    url: "/safe/iot/voice/schedule/type/del"
  },

  // 获取作息表任务列表
  getBroadcastRestTask: {
    method: "get",
    url: "/safe/iot/voice/schedule/configs"
  },

  // 添加或编辑作息表任务
  addOrEditBroadcastRestTask: {
    method: "post",
    url: "/safe/iot/voice/schedule/config/operate"
  },

  // 批量删除作息表任务
  delBroadcastRestTask: {
    method: "post",
    url: "/safe/iot/voice/schedule/configs/del"
  },

  // 复制作息表任务到其它作息表分类
  copyBroadcastRestTask: {
    method: "post",
    url: "/safe/iot/voice/schedule/configs/copy"
  },

  // 获取作息广播列表
  getRestBroadcast: {
    method: "get",
    url: "/safe/iot/voice/schedules"
  },

  // 获取单个作息广播信息
  getRestBroadcastInfo: {
    method: "get",
    url: "/safe/iot/voice/schedule"
  },

  // 添加或编辑作息广播
  addOrEditRestBroadcast: {
    method: "post",
    url: "/safe/iot/voice/schedule/operate"
  },

  // 删除作息广播信息
  delRestBroadcast: {
    method: "get",
    url: "/safe/iot/voice/schedule/del"
  },

  // 获取今日广播列表
  getTodayBroadcast: {
    method: "get",
    url: "/safe/iot/voice/schedule/records"
  },

  // 编辑今日广播状态
  editTodayBroadcast: {
    method: "post",
    url: "/safe/iot/voice/schedule/record/status/edit"
  },

  // 启动定时广播任务
  startTodayBroadcast: {
    method: "get",
    url: "/safe/iot/voice/task/manual/start"
  },

  // 停止定时广播任务
  stopTodayBroadcast: {
    method: "get",
    url: "/safe/iot/voice/task/manual/stop"
  },

  // 启用/冻结定时广播任务
  operateTodayBroadcast: {
    method: "post",
    url: "/safe/iot/voice/task/enable"
  },

  // 启动定时广播任务(云广播)
  startTodayBroadcastCloud: {
    method: "get",
    url: "/safe/iot/voice/cloud/task/manual/start"
  },

  // 停止定时广播任务(云广播)
  stopTodayBroadcastCloud: {
    method: "post",
    url: "/safe/iot/voice/cloud/task/manual/stop"
  },

  // 获取应急预案列表
  getEmergencyPlanList: {
    method: "get",
    url: "/safe/iot/drill/plan/list"
  },

  // 获取应急方案指挥员列表
  getDirectsList: {
    method: "get",
    url: "/safe/iot/drill/plan/directs"
  },

  // 获取应急预案详情
  getEmergencyPlanDetails: {
    method: "get",
    url: "/safe/iot/drill/plan"
  },

  // 应急预案操作  编辑 / 添加
  emergencyPlanOperation: {
    method: "post",
    url: "/safe/iot/drill/plan/operate"
  },

  // 删除单个应急预案
  delEmergencyPlanDetails: {
    method: "get",
    url: "/safe/iot/drill/plan/del"
  },

  // 批量删除应急预案
  delEmergencyPlanList: {
    method: "get",
    url: "/safe/iot/drill/plan/del/batch"
  },

  // 获取演练疏散图
  getDrillEvacuationMap: {
    method: "get",
    url: "/safe/iot/drill/route"
  },

  // 删除演练疏散图
  delDrillEvacuationMap: {
    method: "get",
    url: "/safe/iot/drill/route/del"
  },

  // 批量删除演练疏散图
  batchDeleteDrillEvacuationMap: {
    method: "post",
    url: "/safe/iot/drill/route/del/batch"
  },

  // 添加 / 修改 演练疏散图
  drillEvacuationMapOperation: {
    method: "post",
    url: "/safe/iot/drill/route/operate"
  },

  // 获取救援器材
  getRescueEquipment: {
    method: "get",
    url: "/safe/iot/drill/device"
  },

  // 删除救援器材
  delRescueEquipment: {
    method: "get",
    url: "/safe/iot/drill/device/del"
  },

  // 批量删除救援器材
  batchDeleteRescueEquipment: {
    method: "post",
    url: "/safe/iot/drill/device/del/batch"
  },

  // 添加 / 修改 救援器材
  rescueEquipmentOperation: {
    method: "post",
    url: "/safe/iot/drill/device/operate"
  },

  // 获取预案下的广播
  getPlanBroadcast: {
    method: "get",
    url: "/safe/iot/drill/plan/voice"
  },

  // 添加预案下的广播
  addPlanBroadcast: {
    method: "post",
    url: "/safe/iot/drill/plan/voice/add"
  },

  // 获取预案下的路线图
  getPlanRoadMap: {
    method: "get",
    url: "/safe/iot/drill/plan/route"
  },

  // 添加预案下的路线图
  addPlanRoadMap: {
    method: "post",
    url: "/safe/iot/drill/plan/route/add"
  },

  // 删除预案下的路线图
  delPlanRoadMap: {
    method: "get",
    url: "/safe/iot/drill/plan/route/del"
  },

  // 获取预案下的救援器材
  getPlanEmergencyEquipment: {
    method: "get",
    url: "/safe/iot/drill/plan/device"
  },

  // 添加预案下的救援器材
  addPlanEmergencyEquipment: {
    method: "post",
    url: "/safe/iot/drill/plan/device/add"
  },

  // 删除预案下的救援器材
  delPlanEmergencyEquipment: {
    method: "get",
    url: "/safe/iot/drill/plan/device/del"
  },

  // 删除预案下的广播
  delPlanBroadcast: {
    method: "get",
    url: "/safe/iot/drill/plan/voice/del"
  },

  // 获取演练记录
  getDrillRecord: {
    method: "get",
    url: "/safe/iot/drill/plan/record"
  },

  // 删除演练记录
  delDrillRecord: {
    method: "get",
    url: "/safe/iot/drill/plan/record/del"
  },

  // 获取演练详情
  delDrillDetails: {
    method: "get",
    url: "/safe/iot/drill/plan/record/details"
  },

  // 获取应急演练中心详情
  getDrillCenterDetails: {
    method: "get",
    url: "/safe/iot/drill/plan/details"
  },

  // 演练启动时添加演练
  addDrill: {
    method: "post",
    url: "/safe/iot/drill/plan/record/add"
  },

  // 添加演练记录具体操作
  addDrillOperation: {
    method: "post",
    url: "/safe/iot/drill/plan/record/content/add"
  },

  // 演练结束时编辑演练记录信息
  editDrillRecord: {
    method: "post",
    url: "/safe/iot/drill/plan/record/edit"
  },

  // 编辑应急预案状态
  editDrillStatus: {
    method: "get",
    url: "/safe/iot/drill/plan/status/edit"
  },

  // 获取应急演练中心直播列表
  getLiveList: {
    method: "get",
    url: "/safe/iot/live/list"
  },

  // 应急广播-创建会话
  createBroadcastSession: {
    method: "post",
    url: "/safe/iot/voice/file/session/cre"
  },

  // 应急广播-播放媒体库文件
  playBroadcast: {
    method: "get",
    url: "/safe/iot//voice/file/session/set/prog"
  },

  // 应急广播-文件广播播放控制
  playControlBroadcast: {
    method: "get",
    url: "/safe/iot/voice/file/session/set/stat"
  },

  // 应急广播-删除文件广播会话
  delBroadcastSession: {
    method: "get",
    url: "/safe/iot/voice/file/session/destory"
  },

  // 云广播播放音乐
  playBroadcastCloud: {
    method: "post",
    url: "/safe/iot/voice/cloud/play/music"
  },

  // 应急广播-获取分区信息
  getBroadcastAreaInfo: {
    method: "get",
    url: "/safe/iot/voice/partition/info"
  },

  // 设置云广播服务器线路输入序号
  setBroadcastLineIndex: {
    method: "get",
    url: "/safe/iot/voice/cloud/source/index/edit"
  },

  // 获取云广播线路输入服务器ip
  getBroadcastLineIp: {
    method: "get",
    url: "/safe/iot/voice/cloud/liserver/ip"
  },

  // 编辑云广播线路输入服务器ip
  editBroadcastLineIp: {
    method: "get",
    url: "/safe/iot/voice/cloud/liserver/ip/edit"
  },

  // 获取云广播自动线路输入自动打开状态
  getBroadcastLineAuto: {
    method: "get",
    url: "/safe/iot/voice/cloud/liserver/auto/source"
  },

  // 设置云广播自动线路输入自动打开状态
  editBroadcastLineAuto: {
    method: "get",
    url: "/safe/iot/voice/cloud/liserver/auto/source/edit"
  },

  // 获取监控设备
  getMonitoringEquipment: {
    method: "get",
    url: "/safe/iot/monitor/device"
  },

  // 获取学校监控品牌
  getMonitorEquipmentBrand: {
    method: "get",
    url: "/safe/iot/monitor/brand"
  },

  // 编辑学校监控品牌
  editMonitorEquipmentBrand: {
    method: "get",
    url: "/safe/iot/monitor/brand/edit"
  },

  // 获取监控设备下的摄像头
  getMonitoringEquipmentCamera: {
    method: "get",
    url: "/safe/iot/monitor/device/camera"
  },

  // 编辑通道状态
  modifyMonitorStatus: {
    method: "get",
    url: "/safe/iot/monitor/camera/status/edit"
  },

  // 添加预案下的摄像头
  addPlanCamera: {
    method: "post",
    url: "/safe/iot/drill/plan/monitor/add"
  },

  // 删除预案下的摄像头
  dlePlanCamera: {
    method: "get",
    url: "/safe/iot/drill/plan/monitor/del"
  },

  // 获取预案下的摄像头
  getPlanCamera: {
    method: "get",
    url: "/safe/iot/drill/plan/monitor"
  },

  // 校园基础信息-右上信息
  getSituationBasicRightTop: {
    method: "post",
    url: "/Security/sumBasicSite"
  },

  // 校园基础信息-右下信息
  getSituationBasicRightBottom: {
    method: "post",
    url: "/Security/rankingBasicSite"
  },

  // 校园基础信息-中间平面图
  getSituationBasicPlaneChart: {
    method: "post",
    url: "/Security/queryPlan"
  },

  // 校园风险隐患-风险分级管控条数统计
  getSituationRiskTotalStatistics: {
    method: "post",
    url: "/risk/getTotal"
  },

  // 校园风险隐患-隐患排查治理数据统计
  getHiddenDangerStatistics: {
    method: "post",
    url: "/Security/checkGovernanceStatistics"
  },

  // 校园风险隐患-巡查率排名Top5
  getPatrolRankingStatistics: {
    method: "post",
    url: "/Security/selInspectionRiskPoints"
  },

  // 校园风险隐患-隐患类型动态分析
  getHazardTypeAnalysis: {
    method: "post",
    url: "/Security/dynamicAnalysisRiskTypesSecond"
  },

  // 校园风险隐患-区域隐患统计
  getRegionalHiddenDanger: {
    method: "post",
    url: "/Kitchen/regionalHiddenDangerStatistics"
  },

  // 校园食品安全-本周食材
  getThisWeekIngredients: {
    method: "post",
    url: "/Kitchen/queryFoodInformation"
  },

  // 校园食品安全-本周食材
  getIngredientsPurchaseTrend: {
    method: "post",
    url: "/Kitchen/queryPurchasingTrend"
  },

  // 校园食品安全-获取食堂基础信息
  getCanteenInfo: {
    method: "post",
    url: "/Kitchen/sel/kitchen/canteen/data"
  },

  // 健康证展示
  getHealthCertificate: {
    method: "post",
    url: "/Kitchen/selecthealthCertificateDisplay"
  },

  // 今日食谱
  getTodayRecipe: {
    method: "post",
    url: "/Kitchen/selectTodayRecipe"
  },

  // 本周食谱
  getWeekRecipe: {
    method: "post",
    url: "/Kitchen/weekTheIngredients"
  },

  // 明厨亮灶
  chefMonitor: {
    method: "post",
    url: "/safe/manage/ChefMonitor/select"
  },

  // 校园监控中心-获取监控区域以及监控列表
  getRegionMonitorList: {
    method: "get",
    url: "/safe/iot/live/address/info"
  },
  // isPull!=0 获取播放地址
  // getPlayUrl: {
  //   method: "get",
  //   url: "/v1/get/play/url"
  // },
  getPlayUrl: {
    method: "get",
    url: "v1/get/play/url/by/code"
  },
  getEzuikitPlayUrl: {
    method: "post",
    url: "v1/get/play/url"
  },

  // 获取学校数据图片
  getSchoolDataPicture: {
    method: "post",
    url: "/Security/queryPlan"
  },

  // 编辑学校数据图片
  setSchoolDataPicture: {
    method: "post",
    url: "/Security/editPlan"
  },

  // 获取学校3D图
  getSchoolThreeDPicture: {
    method: "post",
    url: "/Security/queryTdm"
  },

  // 编辑学校3D图
  setSchoolThreeDPicture: {
    method: "post",
    url: "/Security/editTdm"
  },

  // 获取安全态势的左侧信息
  getSituationLeftData: {
    method: "post",
    url: "/Security/queryShowTheBar"
  },

  // 编辑安全态势的左侧信息
  editSituationLeftData: {
    method: "post",
    url: "/Security/updateBatchShowTheBar"
  },

  // 批量更新建筑排行
  updateBatchBuildingRanking: {
    method: "post",
    url: "/Security/updateBatchBuildingRanking"
  },

  // 新增安全态势的左侧信息
  addSituationLeftData: {
    method: "post",
    url: "/Security/insertShowTheBar"
  },

  // 删除安全态势的左侧信息
  delSituationLeftData: {
    method: "post",
    url: "/Security/delShowTheBar"
  },

  // 排序安全态势的左侧信息
  orderSituationLeftData: {
    method: "post",
    url: "/Security/updUpdateShowTheBar"
  },

  // 新增建筑排行
  addArchitectureRanking: {
    method: "post",
    url: "/Security/insertBuildingRanking"
  },

  // 删除建筑排行
  delArchitectureRanking: {
    method: "post",
    url: "/Security/delBuildingRanking"
  },

  // 获取风险区域
  getRiskRegion: {
    method: "get",
    url: "/risk/area"
  },

  // 新增 / 编辑四色图标签
  gradeChartLabelOperation: {
    method: "post",
    url: "/risk/riskLevel/img/coordinate/operate"
  },

  // 删除四色图标签
  delGradeChartLabel: {
    method: "get",
    url: "/risk/riskLevel/img/coordinate/del"
  },

  // 获取四色图的风险统计
  getGradeChartRiskStatistics: {
    method: "get",
    url: "/risk/riskLevel/img/statistics"
  },

  // 添加监控设备
  addMonitorEquipment: {
    method: "post",
    url: "/safe/iot/monitor/device/add"
  },

  // 编辑监控设备
  editMonitorEquipment: {
    method: "post",
    url: "/safe/iot/monitor/device/edit"
  },

  // 删除监控设备
  delMonitorEquipment: {
    method: "get",
    url: "/safe/iot/monitor/device/del"
  },

  // 删除监控设备
  refreshMonitorEquipmentAddress: {
    method: "get",
    url: "/safe/iot/live/refresh"
  },

  // 获取监控区域
  getMonitoringArea: {
    method: "get",
    url: "/safe/iot/monitor/area"
  },

  // 监控区域操作  添加 / 编辑
  monitoringOperation: {
    method: "post",
    url: "/safe/iot/monitor/area/operate"
  },

  // 删除监控区域
  delMonitoringArea: {
    method: "get",
    url: "/safe/iot/monitor/area/del"
  },

  // 修改通道名称
  setMonitorName: {
    method: "get",
    url: "/safe/iot/monitor/camera/name/edit"
  },

  // 获取监控列表
  getMonitorList: {
    method: "get",
    url: "/safe/iot/monitor/camera"
  },

  // 获取未绑定监控列表
  getNotBindingMonitorList: {
    method: "get",
    url: "/safe/iot/monitor/camera/free"
  },

  // 通道绑定或解绑监控区域
  bindingOrUnbindMonitorArea: {
    method: "get",
    url: "/safe/iot/monitor/camera/operate"
  },

  // 获取学校信息
  getSchoolInfo: {
    method: "post",
    url: "/school/checkSchoolInformation"
  },
    // 获取学校信息
    noticeFile: {
      method: "get",
      url: "/contract/get/notice"
    },
  //记录账号异地登录
  toolUserLogin: {
    method: "post",
    url: "/tools/record/user/login"
  },

  // 修改学校信息
  setSchoolInfo: {
    method: "post",
    url: "/school/editSchoolInformation"
  },

  // 获取学校资质证书
  getSchoolCertificate: {
    method: "post",
    url: "/school/sel/qualificationcertificate/detailed"
  },

  // 添加学校资质证书
  addSchoolCertificate: {
    method: "post",
    url: "/school/ins/sel/qualificationcertificate"
  },

  // 删除学校资质证书
  delSchoolCertificate: {
    method: "post",
    url: "/school/del/qualificationcertificate"
  },

  // 获取学校通讯录
  getMailList: {
    method: "post",
    url: "/school/sel/addressbook/detailed"
  },

  // 添加学校通讯录
  addMailList: {
    method: "post",
    url: "/school/sel/ins/addressbook"
  },

  // 删除学校通讯录
  delMailList: {
    method: "post",
    url: "/school/del/addressbook"
  },

  // 获取组织架
  getOrganizationFramework: {
    method: "post",
    url: "/school/sel/management/structure"
  },

  // 编辑组织架
  editOrganizationFramework: {
    method: "post",
    url: "/school/upd/management/structure"
  },

  // 获取组织架构图
  getOrganizationFrameworkPicture: {
    method: "post",
    url: "/school/sel/organisationchart"
  },

  // 修改组织架构图
  setOrganizationFrameworkPicture: {
    method: "post",
    url: "/school/upd/organisationchart"
  },

  // 获取校园动态
  getSchoolDynamic: {
    method: "post",
    url: "/campuscn/sel/thecampus"
  },

  // 删除校园动态
  delSchoolDynamic: {
    method: "post",
    url: "/campuscn/deleteTheCampus"
  },

  // 新增校园动态
  addSchoolDynamic: {
    method: "post",
    url: "/campuscn/insert/thecampus"
  },

  // 获取教师风采
  getTeacherStyle: {
    method: "post",
    url: "/campuscn/inquire/thecampus"
  },

  // 删除教师风采
  delTeacherStyle: {
    method: "post",
    url: "/campuscn/deleteTeacher"
  },

  // 教师风采置顶
  teacherStyleUp: {
    method: "post",
    url: "/campuscn/update/stick"
  },

  // 新增教师风采
  addTeacherStyle: {
    method: "post",
    url: "/campuscn/insert/teacherpresence"
  },

  // 获取班级风采
  getClassStyle: {
    method: "post",
    url: "/campuscn/sel/classstyle"
  },

  // 删除班级风采
  delClassStyle: {
    method: "post",
    url: "/campuscn/deleteClassStyle"
  },

  // 新增班级风采
  addClassStyle: {
    method: "post",
    url: "/campuscn/insert/classstyle"
  },

  // 获取安保档案
  getSecurityArchives: {
    method: "get",
    url: "/safe/archive/security/guard"
  },

  // 删除安保档案
  delSecurityArchives: {
    method: "post",
    url: "/safe/archive/security/guard/del"
  },

  // 安保档案详情
  detailsSecurityArchives: {
    method: "get",
    url: "/safe/archive/security/guard/info"
  },

  // 导出安保档案
  exportSecurityArchives: {
    method: "get",
    url: "/safe/archive/security/guard/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导入安保档案
  importSecurityArchives: {
    method: "post",
    url: "/safe/archive/security/guard/import"
  },

  // 安全档案操作  添加 / 编辑
  operationSecurityArchives: {
    method: "post",
    url: "/safe/archive/security/guard/operate"
  },

  // 获取消防档案
  getFireArchives: {
    method: "get",
    url: "/safe/archive/fire/fighting"
  },

  // 删除消防档案
  delFireArchives: {
    method: "post",
    url: "/safe/archive/fire/fighting/del"
  },

  // 消防档案详情
  detailsFireArchives: {
    method: "get",
    url: "/safe/archive/fire/fighting/info"
  },

  // 导出消防档案
  exportFireArchives: {
    method: "get",
    url: "/safe/archive/fire/fighting/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导入消防档案
  importFireArchives: {
    method: "post",
    url: "/safe/archive/fire/fighting/import"
  },

  // 消防档案操作  添加 / 编辑
  operationFireArchives: {
    method: "post",
    url: "/safe/archive/fire/fighting/operate"
  },

  // 获取校车档案
  getSchoolBusArchives: {
    method: "get",
    url: "/safe/archive/school/bus"
  },

  // 删除校车档案
  delSchoolBusArchives: {
    method: "post",
    url: "/safe/archive/school/bus/del"
  },

  // 校车档案详情
  detailsSchoolBusArchives: {
    method: "get",
    url: "/safe/archive/school/bus/info"
  },

  // 导出校车档案
  exportSchoolBusArchives: {
    method: "get",
    url: "/safe/archive/school/bus/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导入校车档案
  importSchoolBusArchives: {
    method: "post",
    url: "/safe/archive/school/bus/import"
  },

  // 校车档案操作  添加 / 编辑
  operationSchoolBusArchives: {
    method: "post",
    url: "/safe/archive/school/bus/operate"
  },

  // 获取器械档案
  getApparatusArchives: {
    method: "get",
    url: "/safe/archive/apparatus"
  },

  // 删除器械档案
  delApparatusArchives: {
    method: "post",
    url: "/safe/archive/apparatus/del"
  },

  // 器械档案详情
  detailsApparatusArchives: {
    method: "get",
    url: "/safe/archive/apparatus/info"
  },

  // 导出器械档案
  exportApparatusArchives: {
    method: "get",
    url: "/safe/archive/apparatus/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 导入器械档案
  importApparatusArchives: {
    method: "post",
    url: "/safe/archive/apparatus/import"
  },

  // 器械档案操作  添加 / 编辑
  operationApparatusArchives: {
    method: "post",
    url: "/safe/archive/apparatus/operate"
  },

  // 获取职务列表
  getSchoolJobList: {
    method: "post",
    url: "/safetyinformation/sel/office/management"
  },

  // 新增职务列表
  addSchoolJobData: {
    method: "post",
    url: "/safetyinformation/ins/office/management"
  },

  // 编辑职务列表
  editSchoolJobData: {
    method: "post",
    url: "/safetyinformation/upd/office/management"
  },

  // 编辑职务详情
  getSchoolJobDetails: {
    method: "post",
    url: "/safetyinformation/sel/job/details"
  },

  // 删除职务
  delSchoolJobData: {
    method: "post",
    url: "/safetyinformation/delete/job/title"
  },

  // 添加职务成员
  addSchoolJobMember: {
    method: "post",
    url: "/safetyinformation/ins/office/list"
  },

  // 删除职务成员
  delSchoolJobMember: {
    method: "post",
    url: "/safetyinformation/batch/del/office/liststaff"
  },

  //  获取宿舍楼列表
  getApartmentList: {
    method: "get",
    url: "/safe/manage/show/all/dormitory/buildings"
  },

  //  新增宿舍楼
  addApartment: {
    method: "post",
    url: "/safe/manage/new/dormitory/building"
  },

  //  编辑宿舍楼信息
  editApartment: {
    method: "post",
    url: "/safe/manage/edit/dormitory"
  },

  //  批量删除宿舍
  delApartment: {
    method: "post",
    url: "/safe/manage/delete/dormitory/buildings/in/batch"
  },

  //  获取房间列表
  getApartmentRoomList: {
    method: "get",
    url: "/safe/manage/show/all/rooms"
  },

  //  新增房间
  addApartmentRoom: {
    method: "post",
    url: "/safe/manage/add/room/information"
  },

  //  编辑房间信息
  editApartmentRoom: {
    method: "post",
    url: "/safe/manage/edit/dormitory/room"
  },

  //  删除房间
  delApartmentRoom: {
    method: "post",
    url: "/safe/manage/delete/rooms/in/bulk"
  },

  //  展示人员列表
  getApartmentPerson: {
    method: "get",
    url: "/safe/manage/show/room/personnel"
  },

  //  获取班级学生
  getStudent: {
    method: "get",
    url: "/user/get/acquire/class/students"
  },

  //  新增人员
  addApartmentPerson: {
    method: "post",
    url: "/safe/manage/new/personnel/information"
  },

  //  编辑人员信息
  editApartmentPerson: {
    method: "post",
    url: "/safe/manage/edit/room/staff"
  },

  //  批量删除人员
  delApartmentPerson: {
    method: "post",
    url: "/safe/manage/delete/people/in/bulk"
  },

  // 获取老师部门
  getTeacherDepartment: {
    method: "post",
    url: "/safetyinformation/sel/depart/ment"
  },

  // 获取老师列表
  getTeacherList: {
    method: "post",
    url: "/safetyinformation/sel/user/information"
  },

  // 获取老师详情
  getTeacherDetails: {
    method: "post",
    url: "/safetyinformation/teacher/personal/information/display"
  },

  // 添加老师信息
  addTeacherData: {
    method: "post",
    url: "/safetyinformation/ins/user/information"
  },

  // 编辑老师信息
  editTeacherData: {
    method: "post",
    url: "/safetyinformation/teacher/information/update"
  },

  // 删除老师信息(废弃)
  // delTeacherData: {
  //     method: 'post',
  //     url: '/safetyinformation/del/user/informations',
  // },

  // 删除老师信息(新)
  delTeacherData: {
    method: "post",
    url: "/user/del"
  },

  // 批量删除老师信息(新)
  delMultiTeacherData: {
    method: "post",
    url: "/user/del/user"
  },

  // 禁用老师
  disableTeacher: {
    method: "post",
    url: "/safetyinformation/upd/user/account/statusdown"
  },

  // 启用老师
  enableTeacher: {
    method: "post",
    url: "/safetyinformation/upd/user/account/statusup"
  },

  // 禁用和启用用户（老师）
  disableOrEnableUser: {
    method: "post",
    url: "/safetyinformation/account/number/enable/disable"
  },
  // 导入教师档案
  importTeacherArchives: {
    method: "post",
    url: "/safetyinformation/ins/user/information/batch"
  },

  // 导出教师档案
  exportTeacherArchives: {
    method: "get",
    url: "/safetyinformation/export/personnel/information",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取全部的班级列表
  getAllClassList: {
    method: "post",
    url: "/safetyinformation/get/alist/of/classes"
  },

  // 新增学生数据
  addStudentData: {
    method: "post",
    url: "/safetyinformation/add/student/information"
  },

  // 删除学生数据
  delStudentData: {
    method: "post",
    url: "/safetyinformation/delete/student/information/inbulk"
  },

  // 编辑学生数据
  editStudentData: {
    method: "post",
    url: "/safetyinformation/update/student/information"
  },

  // 获取学生数据
  getStudentData: {
    method: "post",
    url: "/safetyinformation/student/information/fuzzy/display"
  },

  // 获取学生数据详情
  getStudentDataDetails: {
    method: "post",
    url: "/safetyinformation/get/student/details"
  },

  // 导入学生档案
  importStudentArchives: {
    method: "post",
    url: "/safetyinformation/ins/user/information/batch"
  },

  // 导出学生档案
  exportStudentArchives: {
    method: "get",
    url: "/safetyinformation/student/personal/information/export",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取家长信息
  getParentsData: {
    method: "get",
    url: "/safetyinformation/sel/parent/information"
  },

  // 新增家长信息
  addParentsData: {
    method: "post",
    url: "/safetyinformation/ins/other/users"
  },

  // 编辑家长信息
  editParentsData: {
    method: "post",
    url: "/safetyinformation/upd/user/information"
  },

  // 删除家长信息
  delParentsData: {
    method: "post",
    url: "/safetyinformation/del/parent/information"
  },

  // 学生家长导入
  importParentsData: {
    method: "post",
    url: "/safetyinformation/import/parent/information"
  },

  // 获取学校班级
  getSchoolClassList: {
    method: "post",
    url: "/safetyinformation/view/class/list"
  },

  // 新增学校班级
  addSchoolClass: {
    method: "post",
    url: "/safetyinformation/new/class"
  },

  // 删除学校班级
  delSchoolClass: {
    method: "post",
    url: "/safetyinformation/delete/class/lists/inbulk"
  },

  // 编辑学校班级
  editSchoolClass: {
    method: "post",
    url: "/safetyinformation/update/asingle/class"
  },

  // 获取班级摄像头
  getClassCamera: {
    method: "post",
    url: "/safetyinformation/camera/list/display"
  },

  // 添加班级摄像头
  addClassCamera: {
    method: "post",
    url: "/safetyinformation/camera/list/added"
  },

  // 删除班级摄像头
  delClassCamera: {
    method: "post",
    url: "/safetyinformation/camera/list/bulk/delete"
  },

  // 获取班级老师
  getClassTeacher: {
    method: "post",
    url: "/safetyinformation/teacher/list/display"
  },

  // 删除班级老师
  delClassTeacher: {
    method: "post",
    url: "/safetyinformation/delete/class/list/teacher"
  },

  // 添加班级老师
  addClassTeacher: {
    method: "post",
    url: "/safetyinformation/add/teacher/to/class"
  },

  // 获取班级学生
  getClassStudent: {
    method: "post",
    url: "/safetyinformation/view/list/class/students"
  },

  // 删除班级学生
  delClassStudent: {
    method: "post",
    url: "/safetyinformation/students/leave/class/batches"
  },

  // 添加班级学生
  addClassStudent: {
    method: "post",
    url: "/safetyinformation/students/join/classes/batches"
  },

  // 获取未分配班级学生
  getUnassignedClassStudent: {
    method: "post",
    url: "/safetyinformation/view/list/unassigned/students"
  },

  // 获取短信列表
  getMessageAuthorityList: {
    method: "post",
    url: "/safetyinformation/sel/sending/settings"
  },

  // 更新短信设置
  updateMessageAuthoritySettings: {
    method: "post",
    url: "/safetyinformation/upd/batch/sending/settings"
  },

  // PC权限列表
  pcAuthorityList: {
    method: "post",
    url: "/school/show/pc/authorization/moduleList"
  },

  // APP权限列表
  appAuthorityList: {
    method: "post",
    url: "/school/display/the/list/app/authorization/modules"
  },

  // 获取已授权的权限列表
  getAuthorizationList: {
    method: "post",
    url: "/school/role/display/authorization/column"
  },

  // 删除已授权的权限列表
  delAuthorizationList: {
    method: "post",
    url: "/school/uncheck/authorization"
  },

  // 添加已授权的权限列表
  addAuthorizationList: {
    method: "post",
    url: "/school/role/bulk/authorization/insertion"
  },

  // 获取巡查值班数据
  getPatrolDutyList: {
    method: "get",
    url: "/safe/manage/duty/report"
  },

  // 导出导出巡查值班记录
  exportPatrolDutyList: {
    method: "get",
    url: "/safe/manage/duty/report/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取巡查值班详情数据
  getPatrolDutyDetails: {
    method: "get",
    url: "/safe/manage/duty/report/info"
  },

  // 删除巡查值班数据
  delPatrolDutyData: {
    method: "post",
    url: "/safe/manage/duty/report/del"
  },

  // 学校-创建/编辑安全会议
  operateSchoolMeetings: {
    method: "post",
    url: "/safe/manage/add/meeting/sign/in"
  },

  // 学校-获取会议列表
  getSchoolMeetings: {
    method: "post",
    url: "/safe/manage/get/all/meetings"
  },

  // 学校-删除会议
  delSchoolMeetings: {
    method: "post",
    url: "/safe/manage/delete/meetings/in/bulk"
  },

  // 学校-查看签到记录
  getSchoolMeetingsRecords: {
    method: "get",
    url: "/safe/manage/view/check/in/records"
  },

  // 获取食堂数据
  getCanteenData: {
    method: "post",
    url: "/safe/manage/get/canteen/details"
  },

  // 编辑食堂数据
  editCanteenData: {
    method: "post",
    url: "/safe/manage/with/the/new/cafeteria/details"
  },

  // 获取食堂员工列表
  getCanteenStaffList: {
    method: "post",
    url: "/safe/manage/get/alist/employee/details"
  },

  // 删除食堂员工
  delCanteenStaff: {
    method: "post",
    url: "/safe/manage/delete/canteen/employees/in/bulk"
  },

  // 新增食堂员工
  addCanteenStaff: {
    method: "post",
    url: "/Kitchen/insertKitchenEmployee"
  },

  // 编辑食堂员工
  editCanteenStaff: {
    method: "post",
    url: "/safe/manage/update/employee/details"
  },

  // 获取学校食堂供应商
  getSchoolSupplierList: {
    method: "post",
    url: "/safe/manage/query/basic/supplier/information"
  },

  // 删除学校食堂供应商
  delSchoolSupplier: {
    method: "post",
    url: "/safe/manage/delete/vendors/in/bulk"
  },

  // 添加学校食堂供应商
  addSchoolSupplier: {
    method: "post",
    url: "/safe/manage/new/supplier/basic/information"
  },

  // 编辑学校食堂供应商
  editSchoolSupplier: {
    method: "post",
    url: "/safe/manage/update/basic/supplier/information"
  },

  // 获取食品制度列表
  getFoodSystemList: {
    method: "post",
    url: "/safe/manage/view/list/school/systems"
  },

  // 删除食品制度
  delFoodSystem: {
    method: "post",
    url: "/safe/manage/bulk/delete/school/system"
  },

  // 新增食品制度
  addFoodSystem: {
    method: "post",
    url: "/safe/manage/new/school/system"
  },

  // 编辑食品制度
  editFoodSystem: {
    method: "post",
    url: "/safe/manage/edit/school/system"
  },

  // 删除文件
  delFile: {
    method: "post",
    url: "/file/del"
  },

  // 获取食品制度模版列表
  getFoodSystemTemplateList: {
    method: "post",
    url: "/safe/manage/school/system/template/display"
  },

  // 删除食品制度模版
  delFoodSystemTemplate: {
    method: "post",
    url: "/safe/manage/delete/school/system/template"
  },

  // 新增食品制度模版
  addFoodSystemTemplate: {
    method: "post",
    url: "/safe/manage/new/school/system/template"
  },

  // 编辑食品制度模版
  editFoodSystemTemplate: {
    method: "post",
    url: "/safe/manage/update/school/system/template"
  },

  // 新增周餐次
  addWeekMenuList: {
    method: "post",
    url: "/safe/manage/create/meal/times"
  },

  // 获取周菜单
  getWeekMenuList: {
    method: "post",
    url: "/safe/manage/check/meal/list"
  },

  //  删除周餐次
  deleteWeekMenuList: {
    method: "post",
    url: "/safe/manage/delete/asingle/meal/list"
  },

  //  更新周餐次
  updateWeekMenuList: {
    method: "post",
    url: "/safe/manage/update/meal/list"
  },

  // 新增食物信息
  addFoodMaterial: {
    method: "post",
    url: "/Kitchen/insertFoodInformation"
  },

  // 删除食物信息
  delFoodMaterial: {
    method: "post",
    url: "/safe/manage/delete/food/in/bulk"
  },

  // 展示食材列表
  getFoodMaterialsList: {
    method: "post",
    url: "/safe/manage/see/all/ingredients/list"
  },

  // 更新食材信息
  updateFoodMaterial: {
    method: "post",
    url: "/safe/manage/update/food/details"
  },

  // 供应商选择
  selectSupplier: {
    method: "post",
    url: "/safe/manage/supplier/drop/down/selection"
  },

  // 新增留样记录
  addSample: {
    method: "post",
    url: "/safe/manage/add/sample/record"
  },

  // 留样记录展示
  getSampleList: {
    method: "post",
    url: "/safe/manage/display/sample/record"
  },

  // 更新留样记录
  updateSample: {
    method: "post",
    url: "/safe/manage/update/sample/record"
  },

  // 删除留样记录
  delSample: {
    method: "post",
    url: "/safe/manage/delete/sample/record"
  },

  // 新增抽样记录
  addSampleTest: {
    method: "post",
    url: "/safe/manage/new/sampling/record"
  },

  // 抽样记录展示
  getSampleTestList: {
    method: "post",
    url: "/safe/manage/display/sampling/records"
  },

  // 更新抽样记录
  updateSampleTest: {
    method: "post",
    url: "/safe/manage/update/sampling/records"
  },

  // 删除抽样记录
  delSampleTest: {
    method: "post",
    url: "/safe/manage/delete/sampling/records"
  },

  // 获取食堂(明厨亮灶)
  getCanteenCameraCanteenList: {
    method: "get",
    url: "/safe/manage/get/list/canteens"
  },

  // 获取餐厅摄像头列表
  getCanteenCameraList: {
    method: "post",
    url: "/safe/manage/chef/monitor/page"
  },

  // 删除餐厅摄像头
  delCanteenCamera: {
    method: "post",
    url: "/safe/manage/batches/chef/monitor/delete"
  },

  // 新增餐厅摄像头
  addCanteenCamera: {
    method: "post",
    url: "/safe/manage/chef/monitor/add"
  },

  // 新增陪餐任务
  addMealAccompanyingTask: {
    method: "post",
    url: "/safe/manage/added/catering/task/management"
  },

  // 更新陪餐任务
  updateMealAccompanyingTask: {
    method: "post",
    url: "/safe/manage/update/escort/task"
  },

  // 删除陪餐任务
  delMealAccompanyingTask: {
    method: "post",
    url: "/safe/manage/delete/accompanying/tasks/in/bulk"
  },

  // 展示陪餐任务
  getMealAccompanyingTaskList: {
    method: "post",
    url: "/safe/manage/get/details/catering/tasks"
  },

  // 批量启用/禁用 陪餐任务状态
  setMealAccompanyingTaskStatus: {
    method: "post",
    url: "/safe/manage/oc/accompanying/meals"
  },

  // 展示陪餐记录
  getMealAccompanyingRecords: {
    method: "post",
    url: "/safe/manage/obtain/accompany/meal/records/computer"
  },

  // 新增人脸设备
  addFaceDevice: {
    method: "post",
    url: "/app/new/face/device"
  },

  // 人脸设备列表
  getFaceDevice: {
    method: "get",
    url: "/app/display/equipment/list"
  },

  // 删除人脸设备
  delFaceDevice: {
    method: "post",
    url: "/app/delete/face/device"
  },

  // 人脸设备-查看报警信息
  getFaceDeviceAlert: {
    method: "post",
    url: "/app/get/all/information/about/face/recognition"
  },

  // 获取资源分类列表
  getResourceClassification: {
    method: "post",
    url: "/safeeducation/display/resource/classification"
  },

  // 新增父及分类
  addResourceClassificationOne: {
    method: "post",
    url: "/safeeducation/new/resource/classification/parent"
  },

  // 新增子及分类
  addResourceClassificationTwo: {
    method: "post",
    url: "/safeeducation/new/resource/classification/subclass"
  },

  // 删除父及分类
  delResourceClassificationOne: {
    method: "post",
    url: "/safeeducation/delete/category/parent"
  },

  //删除子及分类
  delResourceClassificationTwo: {
    method: "post",
    url: "/safeeducation/delete/resource/classification/subclass"
  },

  // 编辑父及分类
  editResourceClassificationOne: {
    method: "post",
    url: "/safeeducation/edit/resource/category/parent"
  },

  //编辑子及分类
  editResourceClassificationTwo: {
    method: "post",
    url: "/safeeducation/edit/resource/classification/subclasses"
  },

  // 获取公共安全知识
  // getPublicSafetyKnowledge:{
  //     method: 'post',
  //     url: '/safeeducation/display/list/public/resources',
  // },

  // 展示教育视频
  getClassEducationVideo: {
    method: "post",
    url: "/safeeducation/view/safety/education/videos"
  },

  // 获取自定义题库
  getQuestionBank: {
    method: "get",
    url: "/safeeducation/sel/question/bank"
  },

  // 创建自定义题库
  addQuestionBank: {
    method: "post",
    url: "/safeeducation/ins/question/bank"
  },

  // 编辑题库
  editQuestionBank: {
    method: "post",
    url: "/safeeducation/upd/question/bank"
  },

  // 删除题库
  delQuestionBank: {
    method: "post",
    url: "/safeeducation/del/question/bank"
  },

  // 获取双重预防考试题
  getSafePaper: {
    method: "get",
    url: "/safeeducation/sel/question"
  },

  // 新增双重预防考核题
  addSafePaperQuestion: {
    method: "post",
    url: "/safeeducation/add/question"
  },

  // 编辑习题
  editSafePaperQuestion: {
    method: "post",
    url: "/safeeducation/upd/exercises"
  },

  // 删除习题
  delSafePaperQuestion: {
    method: "post",
    url: "/safeeducation/del/question"
  },

  // 获取测评记录
  getTestRecords: {
    method: "get",
    url: "/safeeducation/sel/question/recording"
  },

  // 导出测评记录
  exportTestRecords: {
    method: "post",
    url: "/safeeducation/appraisal/record/export",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 考核提交
  getTestScore: {
    method: "post",
    url: "/safeeducation/submit/answer"
  },

  // 获取部门用户
  getDepartmentUser: {
    method: "post",
    url: "/safetyinformation/view/personnel/in/this/department"
  },

  // 删除部门用户
  delDepartmentUser: {
    method: "post",
    url: "/safetyinformation/delete/people/in/bulk"
  },

  // 新增部门用户
  addDepartmentUser: {
    method: "post",
    url: "/safetyinformation/add/department/personnel"
  },

  // 批量删除部门
  delDepartment: {
    method: "post",
    url: "/school/delete/departments/in/batch"
  },

  // 获取专项检查任务
  getSpecialInspectionTask: {
    method: "get",
    url: "/safe/manage/special/inspection/school"
  },

  // 获取专项检查任务详情
  getSpecialInspectionTaskDetails: {
    method: "get",
    url: "/safe/manage/special/inspection/school/details"
  },

  // 编辑学校专项检查任务状态和检查标准状态
  editInspectionInfo: {
    method: "post",
    url: "/safe/manage/special/inspection/school/info/edit"
  },

  // 获取专项检查任务下的学校执行状态
  getSpecialInspectionSchoolInfo: {
    method: "get",
    url: "/safe/manage/special/inspection/school/info"
  },

  // 获取报警记录
  getUserAlarmRecord: {
    method: "post",
    url: "/safe/manage/display/alarm/related/records"
  },

  // 展示接警人员信息
  getUserAlarmInfo: {
    method: "get",
    url: "/safe/manage/display/information/of/the/police/officer"
  },

  // 新增接警人员
  addUserAlarmInfo: {
    method: "post",
    url: "/safe/manage/add/ed/alarm/setting"
  },

  // 更新接警人员
  editUserAlarmInfo: {
    method: "post",
    url: "/safe/manage/update/alarm"
  },

  // 获取公共资源类别
  // getPublicResourceCategory:{
  //     method: 'post',
  //     url: '/safeeducation/back/safety/knowledge/classification',
  // },

  // 获取本地安全知识
  getLocaSafetyKnowledge: {
    method: "post",
    url: "/safeeducation/demonstrate/safety/knowledge"
  },

  // 新增本地安全知识
  addLocaSafetyKnowledge: {
    method: "post",
    url: "/safeeducation/add/security/knowledge"
  },

  // 安全台账-日常巡查统计
  dailyInspectionStatistics: {
    method: "get",
    url: "/safe/account/patrol/statistics"
  },

  // 安全台账-导出日常巡查统计
  exportDailyInspectionStatistics: {
    method: "get",
    url: "/safe/account/patrol/statistics/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 安全台账-获取学校所有日常巡查任务
  getInspectionAllTask: {
    method: "get",
    url: "/safe/account/patrol/list"
  },

  // 安全台账-专项检查统计
  specialInspectionStatistics: {
    method: "get",
    url: "/safe/account/special/inspection/statistics"
  },

  // 安全台账-安全隐患统计
  safetyDangerStatistics: {
    method: "get",
    url: "/safe/account/hidden/trouble/statistics"
  },

  // 安全台账-校际通知统计
  noticeStatistics: {
    method: "get",
    url: "/safe/account/notice/statistics"
  },

  // 安全台账-安全评分统计
  safetyScoreStatistics: {
    method: "get",
    url: "/safe/account/integral/record"
  },

  // 安全台账-获取学校安全报告信息
  getSafetyReportData: {
    method: "get",
    url: "/safe/account/safe/report"
  },

  // 安全台账-导出安全报告
  exportSafetyReport: {
    method: "get",
    url: "/safe/account/safe/report/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 安全台账-预览安全报告
  safetyReportPreview: {
    method: "get",
    url: "/safe/account/safe/report/examine"
  },

  // 登录
  userLogin: {
    method: "post",
    url: "/user/pc/login"
  },

  // 获取教育局信息
  getEduInfo: {
    method: "get",
    url: "/safe/archive/edu/bureau/info"
  },

  // 添加/编辑教育局信息
  sendEduData: {
    method: "post",
    url: "/safe/archive/edu/bureau/operate"
  },

  // 获取教育局列表
  getEduList: {
    method: "get",
    url: "/safe/archive/edu/bureau/subsidiaries"
  },

  // 获取机构部门列表
  getEduDepartmentList: {
    method: "post",
    url: "/school/DepartmentfindPage"
  },

  // 新增机构部门
  addEduDepartmentList: {
    method: "post",
    url: "/school/Departmentofquery"
  },

  // 编辑机构部门
  editEduDepartmentList: {
    method: "post",
    url: "/school/Departmentofquery/edit"
  },

  // 编辑机构部门名称
  editEduDepartmentName: {
    method: "post",
    url: "/school/edit/department/name"
  },
  // 删除机构部门
  delEduDepartmentList: {
    method: "post",
    url: "/school/Batchdeletiondepartment"
  },

  // 获取机构角色
  getEduRole: {
    method: "post",
    url: "/school/show/all/characters"
  },

  // 新增机构角色
  addEduRole: {
    method: "post",
    url: "/school/add/permission/role"
  },

  // 删除机构角色
  delEduRole: {
    method: "post",
    url: "/school/role/bulk/deletion"
  },

  // 编辑机构角色
  editEduRole: {
    method: "post",
    url: "/school/Updaterole"
  },

  // 获取机构用户
  getEduUserList: {
    method: "get",
    url: "/safe/archive/edu/bureau/users"
  },

  // 获取机构的全部部门
  getEduWholeDepartment: {
    method: "get",
    url: "/safe/archive/edu/bureau/departments"
  },

  // 获取机构职务
  getEduDitoes: {
    method: "post",
    url: "/safetyinformation/sel/office/management"
  },

  // 新增机构职务
  addEduDitoes: {
    method: "post",
    url: "/safetyinformation/ins/office/management"
  },

  // 编辑机构职务
  editEduDitoes: {
    method: "post",
    url: "/safetyinformation/upd/office/management"
  },

  // 删除机构职务
  delOneEduDitoes: {
    method: "post",
    url: "/safetyinformation/delete/job/title"
  },

  // 删除机构职务
  getWholeEduRole: {
    method: "post",
    url: "/school/get/role/list"
  },

  // 新增机构用户
  addEduUser: {
    method: "post",
    url: "/safe/archive/edu/bureau/user/operate"
  },

  // 获取机构用户详情
  getEduUserDetails: {
    method: "get",
    url: "/safe/archive/edu/bureau/user/details"
  },

  // 编辑机构用户
  editEduUser: {
    method: "post",
    url: "/safe/archive/edu/bureau/user/operate"
  },

  // 删除机构用户(废弃)
  // delEduUser: {
  //     method: 'post',
  //     url: '/safetyinformation/del/user/informations',
  // },

  // 删除机构用户(新)
  delEduUser: {
    method: "post",
    url: "/user/del"
  },

  //删除机构用户
  delCollegeUser: {
    method: "post",
    url: "/colleges/delete/college/account"
  },

  // 禁用机构用户
  disableEduUser: {
    method: "post",
    url: "/safetyinformation/upd/user/account/statusdown"
  },

  // 启用机构用户
  enableEduUser: {
    method: "post",
    url: "/safetyinformation/upd/user/account/statusup"
  },

  // 获取组织架构(旧sel/managementstructure)
  getEduStructure: {
    method: "post",
    url: "/school/sel/management/structure"
  },

  // 获取下属学校
  getEduSchool: {
    method: "get",
    url: "/safe/archive/edu/bureau/subschools"
  },

  // 获取下属学校(2023.4.27)
  getEduSchoolNew: {
    method: "get",
    url: "/v1/get/school/info"
  },

  // 编辑教育局下属学校状态
  editEduSchoolStatus: {
    method: "get",
    url: "/safe/archive/edu/bureau/subschools/status/edit"
  },

  // 获取下属院系（高校）
  getUnSchoolList: {
    method: "get",
    url: "/safe/archive/get/subordinate/departments"
  },

  // 下属学校操作  新增  /  编辑
  actionEduSchool: {
    method: "post",
    url: "/safe/archive/edu/bureau/subschools/operate"
  },

  // 获取教育局下属街道列表
  getEduBureauList: {
    method: "get",
    url: "/safe/archive/edu/bureau/street/offices"
  },

  // 添加或编辑下属街道
  addOrEditEduBureau: {
    method: "post",
    url: "/safe/archive/edu/bureau/street/offices/operate"
  },

  // 获取下属街道可选负责人
  getBureauUserList: {
    method: "get",
    url: "/safe/archive/edu/bureau/user/list"
  },

  // 获取机构督办小组
  getEduSupervisionGroup: {
    method: "get",
    url: "/safe/archive/edu/bureau/supervise/team"
  },

  // 获取机构督办组长
  getSupervisionLeader: {
    method: "get",
    url: "/safe/archive/edu/bureau/supervise/team/user"
  },

  // 获取机构督办成员
  getSupervisionMember: {
    method: "get",
    url: "/safe/archive/edu/bureau/supervise/team/school"
  },

  // 获取机构检查任务
  getEduInspectionTask: {
    method: "get",
    url: "/safe/manage/special/inspection"
  },

  // 添加专项检查任务
  addEduInspectionTask: {
    method: "post",
    url: "/safe/manage/special/inspection/add"
  },

  // 机构督办小组  新增 / 编辑
  actionEduSupervisionGroup: {
    method: "post",
    url: "/safe/archive/edu/bureau/supervise/team/operate"
  },

  // 获取督办小组下可选街道
  getBureauStreetList: {
    method: "get",
    url: "/safe/archive/edu/bureau/street/list"
  },

  // 删除机构督查小组
  delEduSupervisionGroup: {
    method: "get",
    url: "/safe/archive/edu/bureau/supervise/team/del"
  },

  // 获取专项检查项目
  getEduInspectionProject: {
    method: "get",
    url: "/safe/manage/special/inspection/project"
  },

  //  专项检查操作  新增 、编辑
  actionEduInspectionProject: {
    method: "post",
    url: "/safe/manage/special/inspection/project/opreate"
  },

  //  专项检查操作删除
  delEduInspectionProject: {
    method: "get",
    url: "/safe/manage/special/inspection/project/del"
  },

  //  获取专项指标列表
  getSpecialIndicatorsList: {
    method: "get",
    url: "/safe/manage/special/inspection/project/name"
  },

  // 获取教育局下属学校事故列表
  getEduAccidentList: {
    method: "get",
    url: "/safe/manage/accident/edu"
  },

  // 获取教育局下属学校事故统计
  getEduAccidentStatistic: {
    method: "get",
    url: "/safe/manage/accident/edu/statistics"
  },

  // 获取行政区域信息及教育局id
  getEduAccidentBranch: {
    method: "get",
    url: "/safe/manage/regions"
  },

  // 查看安全事故信息
  getEduAccidentInfo: {
    method: "post",
    url: "/safe/manage/accident/reveal"
  },

  // 获取批示信息
  getEduAccidentComment: {
    method: "post",
    url: "/safe/manage/accident/process"
  },

  // 编辑批示信息
  updateEduAccidentComment: {
    method: "post",
    url: "/safe/manage/accident/process/edit"
  },

  //  获取督办小组列表
  getSupervisionGroupsList: {
    method: "get",
    url: "/safe/manage/special/inspection/supervise/team/name"
  },

  // 获取监控告警设备
  getMonitorAlarmDevice: {
    method: "get",
    url: "/safe/iot/monitor/alarm/device"
  },

  // 添加或编辑监控告警设备
  editMonitorAlarmDevice: {
    method: "post",
    url: "/safe/iot/monitor/alarm/device/operate"
  },

  // 删除监控告警设备
  delMonitorAlarmDevice: {
    method: "get",
    url: "/safe/iot/monitor/alarm/device/del"
  },

  // 监控告警设备布撤防
  updateMonitorAlarmDeviceDefence: {
    method: "get",
    url: "/safe/iot/monitor/alarm/device/defence"
  },

  // 获取监控告警记录
  getMonitorAlarmRecord: {
    method: "get",
    url: "/safe/iot/monitor/alarm/record"
  },

  // 导出监控告警记录
  exportMonitorAlarmRecord: {
    method: "get",
    url: "/safe/iot/monitor/alarm/record/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 教育局大数据中心
  // 获取安全态势
  getEduSecuritySituation: {
    method: "get",
    url: "/edu/data/statistics/security/situation"
  },

  // 获取下属区域安全信息列表
  getEduSecuritySituationJurisdictionalArea: {
    method: "get",
    url: "/edu/data/statistics/sub/area/safe/info"
  },

  // 获取教育局风险统计
  getEduRiskStatistics: {
    method: "get",
    url: "/edu/data/statistics/risk"
  },

  // 获取学校风险统计
  getEduSchoolRiskStatistics: {
    method: "get",
    url: "/edu/data/statistics/risk/school"
  },

  // 获取教育局隐患统计
  getEduHiddenDangerStatistics: {
    method: "get",
    url: "/edu/data/statistics/hidden/trouble"
  },

  // 获取乡镇中心校学校列表
  getTowCenterStatistics: {
    method: "get",
    url: "edu/data/statistics/town/center/schools"
  },

  // 获取学校隐患统计
  getEduSchoolHiddenDangerStatistics: {
    method: "get",
    url: "/edu/data/statistics/hidden/trouble/school"
  },

  // 获取教育局下各个学校隐患信息
  getEduSchoolHiddenDangerInfo: {
    method: "get",
    url: "/edu/data/statistics/hidden/trouble/list"
  },

  // 获取教育局档案统计
  getEduFilesStatistics: {
    method: "get",
    url: "/edu/data/statistics/dossier"
  },

  // 获取安全地图（单个学校信息）
  getEduSchoolSafetyMap: {
    method: "post",
    url: "/districteb/education/bureau/school/details"
  },
  // 获取行政区域（树形结构）
  getRegionList: {
    method: "get",
    url: "/safe/archive/edu/bureau/region/codes"
  },
  // 获取教育局（树形结构）
  getEduDataList: {
    method: "get",
    url: "/safe/archive/edu/bureau/subedu"
  },
  // 获取学校风险统计
  getStatisticsRiskList: {
    method: "get",
    url: "/edu/data/statistics/risk"
  },
  // 风险统计根据学校id查询报表数据
  getSchoolRisKInfo: {
    method: "get",
    url: "/edu/data/statistics/risk/school"
  },
  // 获取教育局档案统计
  getDossierInfo: {
    method: "get",
    url: "/edu/data/statistics/dossier"
  },
  // 获取安全地图区域列表
  getMapAreaList: {
    method: "get",
    url: "/districteb/get/boot/area"
  },

  // 学校教育局地图上的位置
  getTheSchoolButtonArea: {
    method: "get",
    url: "/districteb/get/the/school/button/area"
  },

  // 学校教育局地图上的位置
  getEduDetails: {
    method: "get",
    url: "/districteb/education/bureau/pop/up/details"
  },

  // 学校教育局地图上的位置
  getEduDetailsCopy: {
    method: "get",
    url: "/districteb/get/map/location"
  },

  // 获取安全中心
  getEduSafetyCenter: {
    method: "get",
    url: "/edu/data/statistics/security/center"
  },

  // 获取学校监控报警信息（教育局）
  getEduSchoolMonitorAlarm: {
    method: "get",
    url: "/edu/data/statistics/monitor/alarm"
  },

  // 获取学校监控报警信息
  getSchoolDetails: {
    method: "get",
    url: "/districteb/education/bureau/school/details"
  },

  // 获取学校监控报警信息
  getSchoolDetailsCopy: {
    method: "get",
    url: "/districteb/edu/school/details"
  },

  // 获取学校信息及监控信息
  getSchoolList: {
    method: "get",
    url: "/edu/data/statistics/school/infos"
  },

  // 获取教育局监控报警信息
  getEduMonitorAlarm: {
    method: "get",
    url: "/edu/data/statistics/monitor/alarm/edu"
  },

  // 获取地图坐标数据(code)
  getGeoJsonList: {
    method: "get",
    url: "/tool/administrative/area/coordinates"
  },

  // 根据区域编码获取上级教育局信息
  getSuperiorEduInfo: {
    method: "get",
    url: "/edu/data/statistics/superior/edu/info"
  },

  // 获取教育局下属学校id和名称
  getEduSchoolList: {
    method: "get",
    url: "/edu/data/statistics/school/info/list"
  },

  // 根据当前学校id获取后台权限密码
  getPasswordLogin: {
    method: "get",
    url: "/districteb/get/the/default/account/password/login"
  },

  // 根据学校安全态势基础信息左侧信息列表
  getSchoolBasicInfo: {
    method: "get",
    url: "/Security/query/show/the/bar"
  },

  // 根据学校安全态势基础信息右侧学校排名以及评分列表
  getRankingBasicSite: {
    method: "post",
    url: "/Security/rankingBasicSite"
  },

  // 根据学校安全态势基础信息右侧区域评分
  getSumBasicSite: {
    method: "post",
    url: "/Security/sumBasicSite"
  },

  // 根据学校安全态势基础信息中间平面图以及3D图
  getQueryPlan: {
    method: "post",
    url: "/Security/queryPlan"
  },

  // 根据学校安全态势风险隐患风险类型动态分析
  getDynamicAnalysisRiskTypes: {
    method: "post",
    url: "/Security/dynamicAnalysisRiskTypes"
  },

  // 展示食堂列表
  getCanteenList: {
    method: "get",
    url: "/safe/manage/back/to/the/canteen/information/list"
  },

  // 新增食堂
  addCanteen: {
    method: "post",
    url: "/safe/manage/add/canteen"
  },

  // 获取部门人员
  getPersonnelList: {
    method: "get",
    url: "/safe/manage/obtain/department/personnel/information"
  },

  // 删除食堂
  deleteCanteen: {
    method: "post",
    url: "/safe/manage/delete/a/single/canteen"
  },

  // 获取教育局风险管控台账
  getStandingBooks: {
    method: "get",
    url: "/edu/data/statistics/standing/books"
  },

  // 获取学校档案上报数量统计
  getFileList: {
    method: "get",
    url: "/edu/data/statistics/dossier/school/statistics"
  },

  // 获取教育局列表
  getIssuedTasks: {
    method: "get",
    url: "/safe/manage/view/all/issued/tasks"
  },

  // 获取教育局下属学校列表
  getEducationBureau: {
    method: "get",
    url: "/safe/manage/schools/under/the/education/bureau"
  },

  // 下发教育局任务
  addTaskContent: {
    method: "post",
    url: "/safe/manage/institutional/task/issuance"
  },

  // 删除下发教育局任务
  deleteTask: {
    method: "post",
    url: "/safe/manage/delete/education/bureau/tasks/in/bulk"
  },

  // 下发教育局任务
  editTaskContent: {
    method: "post",
    url: "/safe/manage/edit/the/task/content"
  },

  // 统计是否查看
  getIssuedTask: {
    method: "get",
    url: "/safe/manage/view/the/status/of/issued/tasks"
  },

  // 查看上级教育局的下发任务
  getEducationList: {
    method: "get",
    url: "/safe/manage/obtain/the/tasks/issued/by/the/education/bureau"
  },

  // 查看上级教育局的下发任务
  getDetailInfo: {
    method: "post",
    url: "/safe/manage/view/task/details/and/change/status"
  },

  // 上报学校任务
  reportingTasks: {
    method: "post",
    url: "/safe/manage/school/reporting/tasks"
  },

  // 我的上报记录
  getReportedList: {
    method: "get",
    url: "/safe/manage/get/the/list/tasks/reported"
  },

  // 撤销上报任务
  revokeMyTask: {
    method: "post",
    url: "/safe/manage/revoke/my/task"
  },

  // 看任务上报内容
  getReportContent: {
    method: "get",
    url: "/safe/manage/education/bureau/obtains/report/content"
  },

  // 获取隐患详情列表
  getHiddenDangers: {
    method: "get",
    url: "/Security/get/a/list/of/hidden/dangers"
  },

  // 导出隐患
  exportReportHiddenDangers: {
    method: "post",
    url: "/Holiday/export/hidden/danger/data",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 选择窗口下的部门选择
  getDepartmentOfChoices: {
    method: "post",
    url: "/school/Departmentofchoices"
  },

  // 判断是否为小组成员
  whetherMember: {
    method: "get",
    url: "/Holiday/determine/whether/you/are/member"
  },

  // 获取隐患负责人
  getPersonList: {
    method: "get",
    url: "/Holiday/get/the/person/responsible/for/the/hazard"
  },

  // 获取隐患处理人
  getProcessorsList: {
    method: "get",
    url: "/Holiday/get/the/list/of/processors"
  },
  // 维修单展示
  getRepairList: {
    method: "post",
    url: "/safe/manage/reveal/repair/order"
  },
  // 维修上报
  reportRepair: {
    method: "post",
    url: "/safe/manage/add/repair/order"
  },
  // 维修详情
  getRepairDetail: {
    method: "post",
    url: "/safe/manage/repair/order/details"
  },
  // 维修指派
  assignRepair: {
    method: "post",
    url: "/safe/manage/repair/designate"
  },
  // 维修处理
  handleRepair: {
    method: "post",
    url: "/safe/manage/process/repair/order"
  },
  // 维修验收
  inspectRepair: {
    method: "post",
    url: "/safe/manage/repair/acceptance"
  },
  // 维修撤销
  cancelRepair: {
    method: "post",
    url: "/safe/manage/withdraw/repair/order"
  },

  // 导出报修列导出
  exportRepair: {
    method: "post",
    url: "/safe/manage/report/export",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 教育局任务下发---导出任务内容
  reportedTask: {
    method: "get",
    url: "/safe/manage/export/the/content/reported/by/the/school"
  },

  // 教育局任务下发---导出任务内容--新
  exportschoolfile: {
    method: "get",
    url: "/safe/manage/export/school/file",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 教育局任务下发---下载提交的任务
  uploadedTask: {
    method: "get",
    url: "/safe/manage/download/all/attachments/uploaded/by/the/school"
  },

  // 特异体质学生档案--学生选择窗口
  getStudentSelectList: {
    method: "post",
    url: "/safetyinformation/get/list/all/students"
  },
  // 特异体质学生档案--特异体质学生档案列表
  getStudentList: {
    method: "post",
    url: "/safetyinformation/display/a/list/of/unique/students"
  },
  // 特异体质学生档案--新增特异体质学生档案
  addStudentFile: {
    method: "post",
    url: "/safetyinformation/add/specific/physical/student/files"
  },
  // 特异体质学生档案--更新特异体质学生档案
  editStudentFile: {
    method: "post",
    url: "/safetyinformation/update/specific/physical/student/files"
  },
  // 特异体质学生档案--批量删除特异体质学生档案
  deleteStudentFile: {
    method: "get",
    url: "/safetyinformation/bulk/delete/specific/student/profiles"
  },

  // 学生心理健康档案--获取学生心里健康档案信息
  getHealthList: {
    method: "get",
    url: "/safetyinformation/student/hental/health"
  },
  // 学生心理健康档案--添加或编辑学生心里健康档案信息
  addOrEditHentalHealth: {
    method: "post",
    url: "/safetyinformation/student/hental/health/operate"
  },
  // 学生心理健康档案--导入学生心里健康档案
  importHentalHealth: {
    method: "post",
    url: "/safetyinformation/student/hental/health/import"
  },
  // 学生心理健康档案--导出学生心里健康档案
  downloadHentalHealth: {
    method: "get",
    url: "/safetyinformation/student/hental/health/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },
  // 学生心理健康档案--删除学生心里健康档案
  delHentalHealth: {
    method: "get",
    url: "/safetyinformation/student/hental/health/del"
  },

  // 学生心理健康档案--获取突发事件
  getEmergencyList: {
    method: "get",
    url: "/safetyinformation/emergency"
  },
  // 学生心理健康档案--添加或编辑突发事件
  addOrEditEmergency: {
    method: "post",
    url: "/safetyinformation/emergency/operate"
  },
  // 学生心理健康档案--删除突发事件
  delMmergency: {
    method: "get",
    url: "/safetyinformation/emergency/del"
  },
  // 学生心理健康档案--导出突发事件
  downloadMmergency: {
    method: "get",
    url: "/safetyinformation/emergency/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 留守儿童档案--获取留守儿童档案
  getChildrenList: {
    method: "get",
    url: "/safetyinformation/leftover/children"
  },
  // 留守儿童档案--删除留守儿童档案
  delChildrenFile: {
    method: "get",
    url: "/safetyinformation/leftover/children/del"
  },
  // 留守儿童档案--添加或编辑留守儿童档案
  addOrEditChildrenFile: {
    method: "post",
    url: "/safetyinformation/leftover/children/operate"
  },
  // 留守儿童档案--导入留守儿童档案
  importChildrenFile: {
    method: "post",
    url: "/safetyinformation/leftover/children/import"
  },
  // 留守儿童档案--导出留守儿童档案
  downloadChildrenFile: {
    method: "get",
    url: "/safetyinformation/leftover/children/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 定期家访管理--获取定期家访信息
  getHomeVisitsList: {
    method: "get",
    url: "/safetyinformation/home/visits"
  },
  // 定期家访管理--删除定期家访信息
  delHomeVisits: {
    method: "get",
    url: "/safetyinformation/home/visits/del"
  },
  // 定期家访管理--获取单个定期家访信息
  getHomeVisitsInfo: {
    method: "get",
    url: "/safetyinformation/home/visits/info"
  },
  // 定期家访管理--添加或编辑定期家访信息
  addOrEditHomeVisits: {
    method: "post",
    url: "/safetyinformation/home/visits/operate"
  },
  // 定期家访管理--导出定期家访信息
  downloadHomeVisits: {
    method: "get",
    url: "/safetyinformation/home/visits/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 考勤规则--获取考勤规则
  getAttendanceRule: {
    method: "get",
    url: "/access/control/attendance/rule"
  },
  // 考勤规则--添加或编辑考勤规则
  addOrEditAttendanceRule: {
    method: "post",
    url: "/access/control/attendance/rule/operate"
  },
  // 考勤记录--获取考勤记录
  getAttendanceRecord: {
    method: "get",
    url: "/access/control/attendance/record"
  },

  // 考勤记录--导出考勤记录
  exportAttendanceRecord: {
    method: "get",
    url: "/access/control/attendance/record/download",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 访客记录--展示访客记录
  getVisitorRecord: {
    method: "post",
    url: "/access/control/show/visitor/records"
  },

  // 访客记录--导出访客记录
  exportVisitorRecord: {
    method: "get",
    url: "/access/control/export/visitor/records",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 访客记录--新增访客记录
  addVisitorRecord: {
    method: "post",
    url: "/access/control/add/access/record"
  },
  // 访客记录--同意/拒绝预约
  visitorOperation: {
    method: "post",
    url: "/access/control/visitor/cancellation"
  },

  // 学生请假管理--请假列表
  getLeaveList: {
    method: "get",
    url: "/access/control/show/all/leave/information"
  },
  // 学生请假管理--获取部门下的老师
  getTeachersFrom: {
    method: "get",
    url: "/access/control/get/teachers/from/department"
  },
  // 学生请假管理--新增请假
  addLeaveInfo: {
    method: "post",
    url: "/access/control/new/student/leave"
  },
  // 学生请假管理--删除请假
  deleteLeaveInfo: {
    method: "get",
    url: "/access/control/delete/leave/slip"
  },
  // 学生请假管理--审核请假信息
  auditLeaveInfo: {
    method: "post",
    url: "/access/control/update/leave/form"
  },

  // 教育局--问卷调查--获取问卷调查列表
  getInvestigationList: {
    method: "get",
    url: "/safe/manage/investigation"
  },
  // 教育局--问卷调查--添加或编辑教育局问卷调查
  editInvestigationInfo: {
    method: "post",
    url: "/safe/manage/investigation/opreate"
  },
  // 教育局--问卷调查--获取教育局问卷调查信息
  getInvestigationInfo: {
    method: "get",
    url: "/safe/manage/investigation/info"
  },
  // 教育局--问卷调查--发布问卷调查
  publishInvestigation: {
    method: "post",
    url: "/safe/manage/investigation/publish"
  },
  // 教育局--问卷调查--获取发布学校
  getPublishSchool: {
    method: "get",
    url: "/safe/manage/investigation/publish/school"
  },
  // 教育局--问卷调查--删除教育局问卷调查
  delInvestigationInfo: {
    method: "post",
    url: "/safe/manage/investigation/del"
  },
  // 教育局--问卷调查--统计教育局下属学校问卷调查完成详情
  getInvestigationFinishInfo: {
    method: "get",
    url: "/safe/manage/investigation/finish/info"
  },
  // 教育局--问卷调查--教育局问卷调查查看统计
  getInvestigationStatistics: {
    method: "get",
    url: "/safe/manage/investigation/statistics"
  },

  // 学校--问卷调查--获取学校问卷调查列表信息
  getInvestigationRecord: {
    method: "get",
    url: "/safe/manage/investigation/record"
  },
  // 学校--问卷调查--提交
  saveInvestigationRecord: {
    method: "get",
    url: "/safe/manage/investigation/record/status/edit"
  },
  // 学校--问卷调查--获取问卷调查详情（查看）
  getInvestigationDetails: {
    method: "get",
    url: "/safe/manage/investigation/details"
  },
  // 学校--问卷调查--添加或编辑学校问卷调查内容
  investigationOperate: {
    method: "post",
    url: "/safe/manage/investigation/option/record/operate"
  },

  // 学校--通知公告--展示公告列表
  getAnnouncementList: {
    method: "get",
    url: "/complex/application/display/all/notification/announcement/columns"
  },
  // 学校--通知公告--新增通知公告
  addAnnouncementInfo: {
    method: "post",
    url: "/complex/application/make/an/announcement"
  },
  // 学校--通知公告--标记为已读
  mailStatus: {
    method: "post",
    url: "/complex/application/change/mail/status"
  },
  // 学校--通知公告--删除公告
  deleteAnnouncements: {
    method: "post",
    url: "/complex/application/delete/announcements/in/bulk"
  },
  // 学校--通知公告--查看公告详情
  getAnnouncementsInfo: {
    method: "get",
    url: "/complex/application/view/notice/announcement/content"
  },
  // 学校--通知公告--查看阅读详情
  getReaderDetails: {
    method: "get",
    url: "/complex/application/view/reader/details"
  },

  // 学校--安全物联--校园智慧消防--展示智慧消防设备
  // getSafeEquipment: {
  //   method: "get",
  //   url: "/safe/iot/show/smart/fire/equipment"
  // },
  //  getSafeEquipment: {
  //     method: "get",
  //     url: "/fdc/get/device/list"
  //   },
  getSafeEquipment: {
    method: "get",
    url: "/fdc/get/device/list"
  },
  getSafeEquipmenttype: {
    method: "get",
    url: "/fdc/get/protection/type"
  },
  addSafeEquipments: {
    method: "post",
    url: "/fdc/device/add"
  },
  delSafeEquipments: {
    method: "post",
    url: "/fdc/device/delete"
  },
  editSafeEquipments: {
    method: "post",
    url: "/fdc/device/update"
  },
  alarmList: {
    method: "get",
    url: '/fdc/device/alarm/list'
  },
  eduAlarmList: {
    method: "get",
    url: '/fdc/edu/get/device/alarm/list'
  },
  eduStatistics: {
    method: "get",
    url: '/fdc/device/state/statistics'
  },
  todayStatistics: {
    method: "get",
    url: '/fdc/today/alarm/handle'
  },
  schollRanking: {
    method: "get",
    url: '/fdc/get/rating/ranking'
  },
  equipmentexpiration: {
    method: "get",
    url: '/fdc/equipment/expiration/reminder'
  },

  // 学校--安全物联--校园智慧消防--新增智慧消防设备
  addSafeEquipment: {
    method: "post",
    url: "/safe/iot/added/smart/fire/fighting/equipment"
  },
  // 学校--安全物联--校园智慧消防--编辑智慧消防设备
  editSafeEquipment: {
    method: "post",
    url: "/safe/iot/edit/smart/fire/equipment"
  },
  // 学校--安全物联--校园智慧消防--删除智慧消防设备
  delSafeEquipment: {
    method: "post",
    url: "/safe/iot/delete/smart/fire/equipment/in/batches"
  },
  // 学校--安全物联--校园智慧消防--开启关闭短信报警
  editSafeEquipmentSms: {
    method: "post",
    url: "/safe/iot/on/off/sms/alarm"
  },
  // 学校--安全物联--校园智慧消防--查看设备报警信息
  getSafeEquipmentAlert: {
    method: "get",
    url: "/sel/query/alarm/information"
  },
  // 学校--安全物联--校园智慧消防--处理设备报警信息
  handleSafeEquipmentAlert: {
    method: "post",
    url: "/process/alarm/information"
  },
  // 学校--安全物联--校园智慧消防--处理报警详情
  getSafeEquipmentAlertDetail: {
    method: "post",
    url: "/alarm/handling/details"
  },

  // 学校--安全物联--空气检测管理--展示空气检测仪
  getAirTestingList: {
    method: "post",
    url: "/safe/iot/show/air/testing/equipment"
  },

  // 学校--安全物联--空气检测管理--新增空气检测仪
  addAirTestingInfo: {
    method: "post",
    url: "/safe/iot/add/air/testing/equipment"
  },

  // 学校--安全物联--空气检测管理--修改空气检测仪
  editAirTestingInfo: {
    method: "post",
    url: "/safe/iot/edit/air/testing/equipment"
  },

  // 学校--安全物联--空气检测管理--删除空气检测仪
  delAirTestingInfo: {
    method: "post",
    url: "/safe/iot/remove/air/detection/equipment"
  },

  // 学校--疫情防控--校园防控工作指引--获取疫情防控方案(1.疫情防控方案 1.疫情防控知识)
  getEpidemicPlan: {
    method: "get",
    url: "/epidemic/get/the/epidemic/plan"
  },

  // 学校--疫情防控--健康排查表数据
  getHealthDataList: {
    method: "get",
    url: "/epidemic/get/health/data"
  },

  // 学校--疫情防控--导入健康排查表数据
  importHealthList: {
    method: "post",
    url: "/epidemic/import/health/checklist"
  },

  // 学校--通知消息
  getNewsAnnouncementList: {
    method: "get",
    url: "/system/get/news/announcement"
  },

  // 学校--建议反馈
  submitFeedback: {
    method: "post",
    url: "/system/submit/feedback"
  },

  // 学校--安全台账--获取校园安全大数据
  getStatisticsInfo: {
    method: "get",
    url: "/safe/account/data/statistics"
  },

  // 教育局--安全台账--导出台账隐患数据
  exportSafeHiddenDanger: {
    method: "get",
    url: "/districteb/export/hazard/statistics",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 教育局--安全台账--导出巡查差数据
  exportSafePatrol: {
    method: "get",
    url: "/districteb/export/patrol/statistics",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 教育局--安全台账--隐患数据列表
  getSafeHiddenDangerList: {
    method: "get",
    url: "/edu/data/statistics/get/hidden/ledger/statistics"
  },

  // 教育局--安全台账--隐患数据列表(2023.4.27)
  getSafeHiddenDangerListNew: {
    method: "get",
    url: "/v1/get/school/hidden/danger/statistics"
  },

  // 教育局--安全台账--巡查数据列表
  getSafePatrolList: {
    method: "get",
    url: "/edu/data/statistics/get/inspect/ledger/statistics"
  },

  // 教育局--安全台账--巡查数据列表(2023.4.27)
  getSafePatrolListNew: {
    method: "get",
    url: "/v1/get/school/patrol/list"
  },

  // 教育局--安全台账--绩效考核评分--获取评分规则
  getRulesList: {
    method: "get",
    url: "/safe/account/scoring/rules"
  },

  // 教育局--安全台账--绩效考核评分--编辑评分规则
  editRulesInfo: {
    method: "post",
    url: "/safe/account/scoring/rules/edit"
  },

  // 学校--安全管理--待办事项--获取待办列表
  getHiddenDangerToList: {
    method: "get",
    url: "/safe/manage/hidden/danger/to/do"
  },

  // 学校--安全管理--待办事项--查看详情
  updDangerTo: {
    method: "post",
    url: "/safe/manage/upd/danger/to/do"
  },

  // 高校版--院系管理--获取院系账号密码
  getAccountPassword: {
    method: "post",
    url: "/user/get/account/password"
  },

  // 高校版--大数据管理
  getUniversityBigData: {
    method: "post",
    url: "/colleges/university/big/data/display"
  },

  // 高校版--大数据管理(数据列表)
  getUniversityNumber: {
    method: "get",
    url: "/colleges/statistics/eachModule"
  },

  // 高校版--大数据管理(隐患统计)
  getUniversityHiddenData: {
    method: "get",
    url: "/colleges/colleges/hidden/danger/statistics/big/data"
  },

  // 高校版--获取枚举列表
  getMenuList: {
    method: "get",
    url: "/colleges/return/to/department/type"
  },

  // 高校版--大数据管理(安全中心)
  getUniversitySafetyCenter: {
    method: "get",
    url: "/colleges/get/university/security/center"
  },

  // 高校版--大数据管理(安全中心)（总校）
  getHeadUniversitySafetyCenter: {
    method: "get",
    url: "/colleges/obtain/college/monitoring"
  },

  // 高校版--大数据管理(食堂管理)
  getCanteenUnder: {
    method: "get",
    url: "/colleges/get/schoolId/canteen/under/college"
  },

  // 高校版--大数据管理(安全地图)
  getDepartmentU3dList: {
    method: "get",
    url: "/colleges/get/department/u3d"
  },

  // 高校版--大数据管理(安全地图)(总校)
  getHeadDepartmentU3dList: {
    method: "get",
    url: "/colleges/get/college/u3D"
  },

  // 手机号登录--获取验证码
  getVerifyCode: {
    method: "post",
    url: "/user/sending/text/verify/code"
  },

  // 手机号登录--验证码登录
  verifyCodeLogin: {
    method: "post",
    url: "/user/verification/code/login"
  },

  // 修改密码--确定修改
  forgotPassword: {
    method: "post",
    url: "/user/forgot/password"
  },

  // 二维码扫码登录--获取uuid
  getLoginUUID: {
    method: "post",
    url: "/user/generate/login/uuid"
  },

  // 二维码扫码登录--获取扫码状态
  getMonitoringStatus: {
    method: "get",
    url: "/user/pc/monitoring/status"
  },

  // 高校大数据--获取高校下属学校id
  getCollegeList: {
    method: "get",
    url: "/colleges/colleges/faculties"
  },

  // 高校大数据--院系下的隐患
  getCollegeDangersList: {
    method: "post",
    url: "/colleges/hidden/dangers/various/departments"
  },

  // 高校大数据--风险统计
  getCollegeRisk: {
    method: "get",
    url: "/colleges/ledger/data"
  },

  // 后勤总公司--下属院系
  getBoundSchools: {
    method: "post",
    url: "/logistics/view/bound/schools"
  },

  // 后勤总公司--获取安全小组
  getSecurityTeam: {
    method: "get",
    url: "/school/get/security/team"
  },

  // 后勤总公司--获取成员列表
  getPersonnelUsers: {
    method: "post",
    url: "/user/get/tear/service/personnel"
  },

  // 后勤总公司--新增安全小组
  addTeamCreation: {
    method: "post",
    url: "/school/security/team/creation"
  },

  // 后勤总公司--编辑安全小组
  editTeamCreation: {
    method: "post",
    url: "/school/security/team/members/deleted"
  },

  // 后勤总公司--删除安全小组
  delTeamCreation: {
    method: "post",
    url: "/school/del/security/teams/in/bulk"
  },

  // 后勤总公司--获取下属院系
  getAllCollegesLogistics: {
    method: "post",
    url: "/logistics/view/bound/schools"
  },

  // 后勤总公司--所有隐患
  getHiddenDangerLogistics: {
    method: "post",
    url: "/Holiday/check/all/hidden/dangers"
  },

  // 后勤总公司--隐患详情
  getHiddenDangerDetailLogistics: {
    method: "get",
    url: "/Holiday/view/individual/hazards"
  },

  // 后勤总公司--隐患撤销
  cancelHiddenDangerLogistics: {
    method: "post",
    url: "/Holiday/updateInsertthe"
  },

  // 后勤总公司--隐患指派
  assignHiddenDangerLogistics: {
    method: "post",
    url: "/Holiday/InsertAssignhandler"
  },

  // 后勤总公司--隐患转派
  transferHiddenDangerLogistics: {
    method: "post",
    url: "/Holiday/redeploythehiddenstatepass"
  },

  // 后勤总公司--隐患处理
  handleHiddenDangerLogistics: {
    method: "post",
    url: "/Holiday/InsertProcessinghiddentrouble"
  },

  // 后勤总公司--隐患验收
  inspectHiddenDangerLogistics: {
    method: "post",
    url: "/Holiday/Acceptanceofhiddentrouble"
  },

  // 后勤总公司--获取隐患负责人/获取隐患处理人
  getPersonLogistics: {
    method: "post",
    url: "/colleges/get/college/principal"
  },

  // 双重知识库--新增文件
  addKnowledgeFile: {
    method: "post",
    url: "/safeeducation/add/dual/knowledge/base"
  },

  // 双重知识库--文件列表
  getKnowledgeFileList: {
    method: "get",
    url: "/safeeducation/sel/dual/knowledge/base"
  },

  // 双重知识库--文件删除
  delKnowledgeFile: {
    method: "post",
    url: "/safeeducation/del/dual/knowledge/base"
  },

  // 高校--用户绑定工号
  addJobNumber: {
    method: "post",
    url: "/user/bind/college/job/number"
  },

  // 学校--获取监控设备下摄像头列表
  getCameraList: {
    method: "get",
    url: "/safe/iot/monitor/device/camera/list"
  },

  // 学校--获取监控权限信息
  getMonitorsInfo: {
    method: "get",
    url: "/safe/iot/monitors/power"
  },

  // 学校--设置多个监控权限
  powerAdd: {
    method: "post",
    url: "/safe/iot/monitors/power/add"
  },

  // 学校--删除单个监控报警信息
  delAlarmRecord: {
    method: "get",
    url: "/safe/iot/monitor/alarm/record/del"
  },

  // 学校--处理监控报警信息
  handleAlarmRecord: {
    method: "post",
    url: "/safe/iot/monitor/alarm/record/handle"
  },

  // 学校--获取学校双重预防资料
  getSchoolInfoData: {
    method: "get",
    url: "/system/school/material/url"
  },

  // 学校--添加学校双重预防资料
  addSchoolInfoData: {
    method: "post",
    url: "/system/school/material/operate"
  },

  // 学校--获取校车路线
  getSchoolBulRoute: {
    method: "get",
    url: "/home/school/sel/school/bus/route"
  },

  // 学校--删除校车路线
  delSchoolBulRoute: {
    method: "post",
    url: "/home/school/del/school/bus/route"
  },

  // 学校--删除校车路线
  addSchoolBulRoute: {
    method: "post",
    url: "/home/school/ins/school/bus/route"
  },

  // 学校--编辑校车路线
  editSchoolBulRoute: {
    method: "post",
    url: "/home/school/upd/school/bus/route"
  },

  // 学校--获取校车司机信息
  getSchoolBulDriver: {
    method: "get",
    url: "/home/school/sel/school/bus/driver"
  },

  // 学校--删除校车司机信息
  delSchoolBulDriver: {
    method: "post",
    url: "/home/school/del/school/bus/driver"
  },

  // 学校--新增校车司机信息
  addSchoolBulDriver: {
    method: "post",
    url: "/home/school/ins/school/bus/driver"
  },

  // 学校--编辑校车司机信息
  editSchoolBulDriver: {
    method: "post",
    url: "/home/school/upd/school/bus/driver"
  },

  // 学校--获取随车人员信息
  getSchoolBulEntourage: {
    method: "get",
    url: "/home/school/sel/school/bus/entourage"
  },

  // 学校--删除随车人员信息
  delSchoolBulEntourage: {
    method: "post",
    url: "/home/school/del/school/bus/entourage"
  },

  // 学校--新增随车人员信息
  addSchoolBulEntourage: {
    method: "post",
    url: "/home/school/ins/school/bus/entourage"
  },

  // 学校--编辑随车人员信息
  editSchoolBulEntourage: {
    method: "post",
    url: "/home/school/upd/school/bus/entourage"
  },

  // 学校--被访人员库展示人员
  getInterviewedList: {
    method: "post",
    url: "/access/control/interviewed/personnel/database/display/personnel"
  },

  // 学校--被访人员库添加人员
  addInterviewed: {
    method: "post",
    url: "/access/control/add/interviewed/person"
  },

  // 学校--被访人员库删除人员
  delInterviewed: {
    method: "post",
    url: "/access/control/delete/visited/person"
  },

  // 学校--编辑学校风险模型等级
  editSchoolModelLevel: {
    method: "get",
    url: "/risk/model/school/level/edit"
  },

  // 学校--获取风险模型下检查对象
  riskModelTargets: {
    method: "get",
    url: "/risk/model/inspect/targets"
  },

  // 学校--自动化生成台账
  addRiskModel: {
    method: "post",
    url: "/risk/school/model/auto/add"
  },

  // 学校--获取人脸分析列表
  getMonitorFaceList: {
    method: "get",
    url: "/safe/iot/monitor/face/analysis"
  },

  getPcSystemMessage: {
    method: "get",
    url: "/system/return/pc/system/message"
  },

  modifySystemMessageStatus: {
    method: "post",
    url: "/system/view/system/messages"
  },

  getEudU3DInfo: {
    method: "get",
    url: "/colleges/get/acquisition/u3d"
  },

  getSubordinateEdu: {
    method: "get",
    url: "/safe/manage/get/subordinate/edu"
  },

  // 获取环境监测设备报警列表
  getMonitoringAlarm: {
    method: "post",
    url: "/safe/iot/environment/monitoring/alarm"
  },

  // 获取环境监测设备列表
  getMonitoringDevice: {
    method: "get",
    url: "/safe/iot/environment/monitoring/device"
  },

  // 删除环境监测设备
  delMonitoringDevice: {
    method: "get",
    url: "/safe/iot/environment/monitoring/device/del"
  },

  // 添加或编辑环境监测设备信息
  operateMonitoringDevice: {
    method: "post",
    url: "/safe/iot/environment/monitoring/device/operate"
  },

  // 获取前n个环境监测设备报警列表(50)
  getMonitoringAlarmTop: {
    method: "get",
    url: "/safe/iot/environment/monitoring/alarm/top"
  },

  // 获取未读消息个数
  getUnreadMessages: {
    method: "get",
    url: "/system/get/unread/messages"
  },

  // 获取音视频单通道编码能力和配置(仅支持海康云眸)
  getCapabilitiesconfig: {
    method: "get",
    url: "/safe/iot/streaming/channels/capabilitiesconfig"
  },

  // 设置音视频单通道编码配置(仅支持海康云眸)
  editChannelsConfig: {
    method: "post",
    url: "/safe/iot/streaming/channels/config/edit"
  },

  // 法治副校首页，法治宣传--人员简介---列表
  getTeachrStaff: {
    method: "get",
    url: "/safeeducation/sel/teaching/staff"
  },

  // 法治副校首页，法治宣传--人员简介---新增
  addTeachrStaff: {
    method: "post",
    url: "/safeeducation/ins/teaching/staff"
  },

  // 法治副校首页，法治宣传--人员简介---编辑
  editTeachrStaff: {
    method: "post",
    url: "/safeeducation/upd/teaching/staff"
  },

  // 法治副校首页，法治宣传--人员简介---删除
  delTeachrStaff: {
    method: "post",
    url: "/safeeducation/del/teaching/staff"
  },

  // 法治副校首页，法治宣传--授课记录---列表
  getLectureRecords: {
    method: "get",
    url: "/safeeducation/sel/lecture/records"
  },

  // 法治副校首页，法治宣传--授课记录---新增
  addLectureRecords: {
    method: "post",
    url: "/safeeducation/ins/lecture/records"
  },

  // 法治副校首页，法治宣传--授课记录---编辑
  editLectureRecords: {
    method: "post",
    url: "/safeeducation/upd/lecture/records"
  },

  // 法治副校首页，法治宣传--授课记录---删除
  delLectureRecords: {
    method: "post",
    url: "/safeeducation/del/lecture/records"
  },

  // 查看护学记录（永城市学校）
  getProtectList: {
    method: "get",
    url: "/np/ge/school/n/records"
  },
  // 查看护学记录（非永城市学校）
  gethxgschoolRecordsList: {
    method: "get",
    url: "/hxg/get/school/records/list"
  },
  // 查看警校协作
  getProtectActivityList: {
    method: "get",
    url: "/bps/sel/school/activity/guide"
  },

  // 申请警校协作
  addProtectActivity: {
    method: "post",
    url: "/bps/ins/activity/guide"
  },

  // 撤销警校协作
  cancelProtectActivity: {
    method: "post",
    url: "/bps/application/canceled"
  },

  // 获取检查对象行数
  getTargetRow: {
    method: "get",
    url: "/risk/inspect/target/row"
  },
  // 法治副校首页，法治宣传--授课记录---导出
  exportLectureRecords: {
    method: "post",
    url: "/safeeducation/export/lecture/records",
    config: {
      headers: {
        "Content-type": "application/x-download;charset=utf-8"
      },
      responseType: "blob"
    }
  },

  // 获取预设事件
  getProtectEvent: {
    method: "get",
    url: "/bps/sel/event"
  },

  // 获取预设警员
  getProtectPolice: {
    method: "get",
    url: "/bps/sel/staff"
  },

  // 互动记录(与我相关)
  getInteractList: {
    method: "get",
    url: "/bps/sel/work/order"
  },

  // 互动详情
  getInteractDetail: {
    method: "get",
    url: "/bps/get/ticket/details"
  },

  // 新增互动
  addInteract: {
    method: "post",
    url: "/bps/ins/work/order"
  },

  // 互动回复
  replyInteract: {
    method: "post",
    url: "/bps/ins/flow/record"
  },

  // 获取下属机构
  getSubOrganization: {
    method: "get",
    url: "/v1/get/organization"
  },

  // 校长讲安全-查看列表课程
  getPrincipalClass: {
    method: "get",
    url: "/v1/sel/school/curriculums/table"
  },

  // 校长讲安全-上传课程
  uploadPrincipalClass: {
    method: "post",
    url: "/v1/up/school/files"
  },

  // 校长讲安全-删除课程
  delPrincipalClass: {
    method: "post",
    url: "/v1/del/school/files"
  },

  // 校长讲安全-编辑课程
  editPrincipalClass: {
    method: "post",
    url: "/v1/upd/school/files"
  },

  // 校长讲安全-文件上传
  uploadFileTencent: {
    method: "post",
    url: "/up/large/file"
  },


  // 校长讲安全-教育局-获取学校列表
  getPrincipalClassSchool: {
    method: "get",
    url: "/v1/get/school/curriculums/list"
  },

  // 校长讲安全-文件上传
  getPrincipalClassEdu: {
    method: "get",
    url: "/v1/sel/school/curriculums/table"
  },

  // 生成-SIP用户认证ID/视频通道编码ID
  createGenerationNumber: {
    method: "post",
    url: "/v1/generate/number"
  },

  // 编号列表
  getGenerationNumberList: {
    method: "get",
    url: "/v1/get/gb/info/list"
  },

  // 下发通知（教育局）-获取下属机构
  getSubEduList: {
    method: "get",
    url: "/v1/get/organization/list"
  },

  // 下发通知（教育局）-通知消息列表
  getEduNoticesList: {
    method: "get",
    url: "/v1/get/organization/notification/list"
  },

  // 下发通知（教育局）-下发通知消息
  sendEduNotices: {
    method: "post",
    url: "/v1/issue/notice"
  },

  // 下发通知（教育局）-已读未读
  getEduNoticesListSchool: {
    method: "get",
    url: "/v1/get/notification/node/list"
  },

  // 下发通知（学校）-消息列表
  getSchoolNoticesList: {
    method: "get",
    url: "/v1/get/notification/list"
  },

  // 下发通知（学校和教育局）-已未读数
  getNoticesNumber: {
    method: "get",
    url: "/v1/get/unread/message/size"
  },

  // 下发通知（学校）-修改状态
  updateNoticesStatus: {
    method: "post",
    url: "/v1/update/notification/state"
  },

  // 检测GB设备
  checkGBDevice: {
    method: "get",
    url: "/gb28181/get/school/nvr/list/"
  },

  // 检测GB设备-同步数据
  checkGBDeviceSynchronize: {
    method: "post",
    url: "/gb28181/together/step/device/data"
  },

  // 检测GB设备-同步数据
  createNoticesTemplate: {
    method: "post",
    url: "/tools/bulletin/board/automatically/generated"
  },
  getUnitList: {
    method: "get",
    url: "/fdc/get/unit/list"
  },
  bindUnit: {
    method: "post",
    url: "/fdc/binding/unit"
  },
  // 云上会议-会议列表
  cloudMeeting: {
    method: "get",
    url: "/get/cloud/meeting"
  },
  // 云上会议-添加会议
  addCloudMeeting: {
    method: "post",
    url: "/add/cloud/meeting"
  },
  // 云上会议-加入会议
  joinCloudMeeting: {
    method: "post",
    url: "/add/cloud/meeting/records"
  },
  // 云上会议-删除会议
  delCloudMeeting: {
    method: "get",
    url: "/del/cloud/meeting"
  },
  // 云上会议-开启
  editCloudMeeting: {
    method: "post",
    url: "/update/cloud/meeting/status"
  },
  // 云上会议-会议记录
  CloudMeetingList: {
    method: "get",
    url: "/get/cloud/meeting/records"
  },
  // 云上会议-会议列表--学校
  schoolCloudMeetingList: {
    method: "get",
    url: "/get/school/meeting/records"
  },

  // 云点播-设备列表--学校
  schoolDeviceList: {
    method: "get",
    url: "/get/school/device"
  },
  // 云点播-添加设备--学校
  schooladdDevice: {
    method: "post",
    url: "/add/device"
  },
  // 云点播-删除设备--学校
  schoolDelDevice: {
    method: "post",
    url: "/del/device"
  },
  // 云点播-广播资源列表--学校
  schoolResourcesList: {
    method: "get",
    url: "/get/broadcast/resources"
  },
  // 云点播-添加广播资源--学校
  schooladdResource: {
    method: "post",
    url: "/add/broadcast/resources"
  },
  // 云点播-广播资源播放--学校
  playResource: {
    method: "post",
    url: "/play/music"
  },
  // 云点播-广播资源停止--学校
  stopResource: {
    method: "post",
    url: "/stop/music"
  },
  // 报警信息--教育局
  resourceInformation: {
    method: "get",
    url: "/fdc/get/smoke/alarm/information"
  },

  //应急预案列表
  resourcePlan: {
    method: "get",
    url: "/get/all/emergency/plan"
  },
  //添加应急预案
  addResourcePlan: {
    method: "post",
    url: "/add/emergency/plan"
  },
  //编辑应急预案
  editResourcePlan: {
    method: "post",
    url: "/upd/emergency/plan"
  },
  //删除应急预案
  delResourcePlan: {
    method: "post",
    url: "/del/emergency/plan"
  },

  //教育局应急预案
  eduResourcePlan: {
    method: "get",
    url: "/get/school/all/emergency/plan"
  },
  //教育局应急预案详情
  eduResourcePlanMain: {
    method: "get",
    url: "/get/emergency/plan"
  },

    //教育局应急预案详情
    addTaskMangement: {
      method: "get",
      url: "/tool/get/task/management"
    },

    addTaskMangements: {
      method: "post",
      url: "/tool/add/task/management"
    },
    delTaskMangements: {
      method: "post",
      url: "/tool/del/task/management"
    },

     TaskscheduleMangement: {
      method: "get",
      url: "/tool/get/schedule/setting"
    },
    addscheduleMangements: {
      method: "post",
      url: "/tool/add/schedule/setting"
    },
    delscheduleMangements: {
      method: "post",
      url: "/tool/del/schedule/setting"
    },

    eduSafeList:{
       method: "get",
      url: "/v1/get/safe/list"
    },
    addEduSafe:{
      method: "post",
     url: "/add/safe"
   },
    upNoticeFile:{
      method: "post",
      url: "/contract/up/contract/file"
    },
    noReminder:{
      method: "post",
      url: "/contract/no/more/reminders"
    },
    //自定义上传视频
    upReviewVideo:{
      method: "post",
      url: "/v1/up/review/video"
    },
    //自定义删除
    delReviewVideo:{
      method: "post",
      url: "/v1/del/review/video"
    },
    //自定义上传视频
    ReviewVideoList:{
      method: "get",
      url: "/v1/get/review/video"
    },
     //编辑自定义视频
     updateReviewVideo:{
      method: "post",
      url: "/v1/update/review/video"
    },
     //局端视频列表
     eduReviewVideoList:{
      method: "get",
      url: "/v1/edu/get/review/video"
    },

    //导入二维码模板
    exportQrCode:{
      method: "post",
      url: "/school/place/import"
    },
    regionNodes: {
      url: '/nr/get/hxg/school/list',
      method: 'get',

    },
    hxgMonitoringList: {
      url: '/get/hxg/monitoring/list',
      method: 'get',

    },
    hxgCameraPlay: {
      url: '/hik/get/video/cameras/preview/urls',
      method: 'get',

    },
    hxgCameraRotate:{
        url:"/hik/video/ptzs/controlling",
        method:"post"
    },
    hxgCaptureSchoolList: {
      url: '/hxg/get/edu/hxg/school/list',
      method: 'get',

    },
    hxgCaptureDeviceList: {
      url: '/hxg/get/capture/device/list',
      method: 'get',

    },
    hxgMonitorDevice: {
      url: '/hxg/v2/get/monitor/device',
      method: 'get',
    },
  //   获取设备在线
    onlineStatics: {
      url: '/tme/node/online/statics',
      method: 'get',
    },
//   设备学校/tme/school/fire/device/list/query
  getDeviceSchoolListQuery: {
    url: '/tme/school/fire/device/list/query',
    method: 'get',
  },
//   千里眼设备订阅消息 /tme/alarm/subscribe
  alarmSubscribe: {
    url: '/tme/alarm/subscribe',
    method: 'post',
  },



};

// 对象导出去
export default API_LIST;
